<template>
  <div class="valuation-report">
    <VueHtml2pdf :show-layout="false" :float-layout="true" :enable-download="$browserDetect && $browserDetect.isFirefox ? true : false" :preview-modal="false" :paginate-elements-by-height="1400" :filename="'Valuation Report - ' + (this.$route.path.includes('sample') ? 'sample' : this.$route.params.id)" :pdf-quality="2" :manual-pagination="false" pdf-format="a4" pdf-orientation="landscape" pdf-content-width="1150px" ref="html2Pdf" @beforeDownload="beforeDownload($event)" @hasDownloaded="afterDownload($event)" @hasGenerated="afterDownload($event)">
      <section slot="pdf-content" style="text-transform:none!important">
        <div v-if="vestimateReport && vestimateReport.IF" class="pdf_docs report-pdf-file valuation-report" ref="document">
          <section ref="page1" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="banner reprt-bnr page">
              <div class="section_body">
                <img src="/img/pdf_logo.png" alt="" class="company_logo">
                <h1>Business Valuation Report</h1>
                <h6>[{{ vestimateReport.naics }}] {{ headerData.industry }}</h6>
                <ul>
                  <li>Market Area: <span>{{ this.headerData.area }}</span></li>
                  <li>Sales Class: <span>{{ this.headerData.sales_class }}</span></li>
                </ul>
                <div class="bottom_area">
                  <div v-if="this.headerData.client_name" class="left">
                    <h4>Client Name</h4>
                    <div class="logo_wpr">
                      <h3>{{ this.user.client_name }}</h3>
                    </div>
                  </div>
                  <div v-if="this.headerData.developer_name" class="right">
                    <h5>Developed By</h5>
                    <h3>{{ this.user.developer_name }}</h3>
                  </div>
                </div>
              </div>
              <div class="banner_footer">
                <!-- <h6>American Author</h6>-->
                <span class="author"><!--Joyce Meyer-->  </span>
                <span class="date">{{ moment(new Date()).format('MMM Do YYYY') }}</span>
              </div>
            </div>
          </section>
          <section ref="page2" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="company_info page">
              <div class="section_body">
                <ul>
                  <li>
                    <h5>About the Data</h5>
                    <p>Vestimate-Pro Methodology <br/>Market Analysis Values <br/>Data Sources <br/>KPI Scoring
                      <br/>Vestimate Use: Terms and Conditions</p>
                  </li>
                  <li>
                    <h5>Business Value</h5>
                    <p>Your Firm <br/>Asset Sale Value <br/>Equity Sale Value <br/>Key Value Drivers
                      <br/>Historial Vestimate Business Values <br/>Valuation Drivers <br/>Historical Value Trend</p>
                  </li>
                  <li>
                    <h5>Scores</h5>
                    <p>KPI Scores <br/>Other Value Indicators</p>
                  </li>
                  <li>
                    <h5>Company Context</h5>
                    <p>History <br/>Products and Customers <br/>Operations</p>
                  </li>
                  <li>
                    <h5>Market Environment</h5>
                    <p>Industry Market Analysis <br/>Industry Market Benchmarks <br/>Market Population Demographics
                      <br/>Industry Market Context</p>
                  </li>
                  <li>
                    <h5>Financial Analysis</h5>
                    <p>Industry Financial Analysis <br/>Percentages <br/>Dollars <br/>Varience</p>
                  </li>
                  <li>
                    <h5>KPI Details</h5>
                    <p>Summary <br/>Cash Flow-Slovency <br/>Profitability <br/>Efficiency <br/>Debt-Risk</p>
                  </li>
                  <li>
                    <h5>Valuation Approach</h5>
                    <p>General <br/>Business Value Approaches <br/>Industry in Context <br/>Ratio Categories
                      <br/>Key Performance Indicators</p>
                  </li>
                </ul>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="pageIntro" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="overall_score page">
              <div class="section_body">
                <md-card-header class="md-card-header-icon pl-0">
                  <div class="section_title">
                    <h2>INTRODUCTION</h2>
                  </div>
                </md-card-header>
                <md-card-content>
                  <div v-if="vestimateReport && vestimateReport.vestimate" class="md-layout px-1">
                    <div class="md-layout-item md-medium-size-100 mt-0 pt-0 pl-0 pr-0 md-size-100">
                      <md-card class="mt-0 pt-0">
                        <md-card-header class="md-card-header-icon pt-0 mt-0 pl-0 pr-0">
                          <p>
                            Bizminer Vestimate-Pro reports help you understand the value of any firm simply and quickly. No other electronic valuation tool organizes critical information with the level of data integrity and industry detail that results from the integration of Bizminer’s widely-recognized industry financial and market analysis content and its derivative analysis of 30,000 recent business transactions from the DealStats database. Both the Bizminer and DealStats datasets are key components in the analytical toolbox of thousands of certified business valuation professionals.
                            <br/><br/> Vestimate-Pro data sources are distinct and transparent; our financial analysis is utilized by thousands of accounting, valuation, banking and business assistance professionals; by almost one hundred university libraries and by taxing agencies in multiple countries. You won’t find a lot of jargon and overblown claims in our Vestimate-Pro Business Value Reports —just the hard analysis and clear answers you need.
                            <br/><br/> Vestimate-Pro analytical content is updated regularly using the same tested protocols applied to our Industry Market Trend reports, which cover over 9000 industry classifications; and to the trusted industry financial analysis we present for more than 5000 lines of business. Uniquely among published electronic value calculations, the Vestimate-Pro analysis integrates traditional financial metrics with market opportunity and growth analyses from Bizminer’s recognized Industry Market dataset.
                            <br/><br/> Your Vestimate-Pro report includes definitions of every line item and ratio, as well as a simple scoring interface that compares your firm’s performance to the industry peer group.
                            <br/><br/> When you accessed your Vestimate-Pro Report, you chose a comparison peer group that most closely represents the character of your firm. Your peer group is defined by a series of criteria that reflects your selections of:
                          <ul>
                            <li>Industry Segment: <span>{{ this.headerData.industry }}</span></li>
                            <li>Market Analysis Area: <span>{{ this.headerData.area }}</span></li>
                            <li>Sales Class: <span>{{ this.headerData.sales_class }}</span></li>
                          </ul>
                          </p>
                        </md-card-header>
                      </md-card>
                    </div>
                  </div>
                </md-card-content>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="pageIntro2" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="overall_score page">
              <div class="section_body">
                <md-card-content>
                  <div v-if="vestimateReport && vestimateReport.vestimate" class="md-layout">
                    <div class="md-layout-item md-medium-size-100 mt-0 pt-0 md-size-100 pl-0 pr-0">
                      <md-card class="mt-0 pt-0">
                        <md-card-header class="md-card-header-icon pt-0 mt-0 pl-0 pr-0">
                          <p>
                            This report is additionally conditioned by the selection and active integration of 3 of three potential years of firm inputs. While the Vestimate-Pro report offers integrated scoring of 13 financial and market KPIs, only those scored on P4 were selected by the developer for activation.
                            <br/><br/> The Vestimate-Pro report is an informational tool, not a guide to action. Do not use the report in place of a certified valuation, or as the basis of any specific business-related or other financial transaction. For that we recommend obtaining an appraisal from a business broker, a valuation from a certified valuation professional, or both. You should not attempt to use Vestimate-Pro to secure a business or personal loan. Be aware that the Vestimate-Pro report may not consider market or firm idiosyncrasies that can influence the actual value or selling price.
                          </p>
                          <h5 class="Performance Scores mt-4">Your Industry in Context: The NAICS Classification System</h5>
                          <p>
                            The industry you selected fits within the official NAICS (North American Industry Classification System) and Bizminer’s proprietary taxonomy, which breaks out more detailed industries classifications than the NAICS by adding up to eight decimal digits after the NAICS-6 code. The selected industry fits into this hierarchy:
                            <br/><br/>
                          <ul>
                            <li v-for="item in this.industryRollup" :key="item">{{ item }}</li>
                          </ul>
                          </p>
                        </md-card-header>
                      </md-card>
                    </div>
                  </div>
                </md-card-content>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page3" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="about_info page">
              <div class="section_body">
                <div class="section_title">
                  <h2>ABOUT THE DATA</h2>
                  <span class="date">Feb 3rd 2022</span>
                </div>
                <div class="data_box_about">
                  <p>Bizminer data is widely accepted for industry analytical work, benchmarking, valuations, forensics and litigation. Bizminer content is accepted in US Tax Court (Bauer vs. IRS: T.C. Memo. 2012-156) and is utilized by state, provincial and national taxing agencies in the US and Canada.
                  <p>
                  <p>Raw data analyzed for Bizminer reports is sourced from an array of the nation's government and private statistical sources. None of these raw data sources creates the final measures reflected in Bizminer industry profiles. In total, Bizminer accesses over a billion sourced data points from 15 million business operations for each of its twice annual updates covering a 3-5 year time series. Historical data and Bizminer algorithms are used to inform and test projections for non-reporting firms. Data elements are sourced specifically from:</p>
                </div>
                <div class="list_box">
                  <ul>
                    <li>IRS SOI Corporation Tax Book</li>
                    <li>IRS Statistics of Income</li>
                    <li>US Economic Census</li>
                    <li>US Census Quarterly Financial Reports</li>
                    <li>US Census County Business Patterns</li>
                    <li>Bureau of Labor Statistics Monthly Employment Reports</li>
                    <li>Bureau of Labor Statistics Monthly Unemployment Reports</li>
                    <li>Bureau of Labor Statistics Annual Wage Survey</li>
                    <li>Bureau of Labor Statistics Industry Productivity Reports</li>
                    <li>Bureau of Labor Statistics Price Indices</li>
                    <li>National Agricultural Statistical Service</li>
                    <li>US Census Quarterly Financial Reports</li>
                    <li>US Census Retail Trade Report</li>
                    <li>Data Axle</li>
                    <li>DealStats</li>
                    <li>Credit Reporting Agencies</li>
                    <li>American Community Survey</li>
                    <li>While 100% firm coverage is desirable for analysis purposes, the greatest value of Bizminer reports rests in discerning patterns</li>
                    <li>of activity, which are reflected in the large samples used to develop our reports. The overall current coverage of the databases</li>
                    <li>surpasses 13 million active business operations at any point in time.</li>
                    <li>Contact Bizminer at: 2601 Market Street, Camp Hill PA 17011: www.bizminer.com.</li>
                  </ul>
                </div>
                <div class="about_bottom">
                  <p>While 100% firm coverage is desirable for analysis purposes, the greatest value of Bizminer reports rests in discerning patterns of activity, which are reflected in the large samples used to develop our reports. The overall current coverage of the databases surpasses 13 million active business operations at any point in time.</p>
                  <p>As is the case with any databases this large, some errors are inevitable. Some firms are missed and specific information on others is lacking from the database. Not all information received is uniform or complete, resulting in the need to develop projection algorithms for specific industry segments and metrics in some report series. No representation is made as to the accuracy of the databases utilized or the results of subsequent analyses.</p>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page4" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="overall_score page">
              <div class="section_body">
                <!-- <md-card-header class="md-card-header-icon"> -->
                <div class="section_title">
                  <h2>BUSINESS VALUES</h2>
                </div>
                <span v-if="this.companyName"> {{ this.companyName }}</span> <span v-else>Company</span> Values
                <p>
                  Sales approach values are rarely applied to firms with revenue of less than $2.5 million. </p>
                <!-- </md-card-header> -->
                <!-- <md-card-content> -->
                <div v-if="vestimateReport && vestimateReport.vestimate" class="md-layout">
                  <div class="md-layout-item md-medium-size-100 md-size-50 pl-0 pr-0">
                    <profile-card header-color="blue" class="table-card no-header">
                      <template slot="content">
                        <h5 class="table_header mt-0">Asset Sale Value</h5>
                        <table>
                          <tr>
                            <td>Earnings Approach:</td>
                            <td>{{ this.vestimateReport.vestimate.earnings }}</td>
                          </tr>
                          <tr>
                            <td>Sale Approach:</td>
                            <td>{{ this.vestimateReport.vestimate.income }}</td>
                          </tr>
                        </table>
                      </template>
                    </profile-card>
                    <profile-card header-color="blue" class="table-card no-header mt-0">
                      <template slot="content">
                        <h5 class="table_header mt-0">Equity Sale Value </h5>
                        <table>
                          <tr>
                            <td>Earnings Approach:</td>
                            <td>
                              {{
                                this.vestimateReport.vestimate
                                    .earnings_equity
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td>Sale Approach:</td>
                            <td>
                              {{
                                this.vestimateReport.vestimate.income_equity
                              }}
                            </td>
                          </tr>
                        </table>
                      </template>
                    </profile-card>
                    <profile-card header-color="blue" class="table-card no-header mt-0">
                      <template slot="content">
                        <h5 class="table_header mt-0">Key Value Drivers:</h5>
                        <table>
                          <tr v-if="sales_value">
                            <td>Sales:</td>
                            <td>${{ sales_value }}</td>
                          </tr>
                          <tr v-if="sales_growth">
                            <td>
                              Sales Growth {{ vestimateReport.IF['timeSeries'] }}:
                            </td>
                            <td>{{ sales_growth }}</td>
                          </tr>
                          <tr v-if="earning_value && valuationDriversChartData && valuationDriversChartData.series.length > 3">
                            <td>Discretionary Owner Earnings:</td>
                            <td>{{ earning_value }}</td>
                          </tr>
                          <tr v-if="earning_growth && valuationDriversChartData && valuationDriversChartData.series.length > 3">
                            <td>
                              Discretionary Owner Earnings Growth {{ vestimateReport.IF.timeSeries }}:
                            </td>
                            <td>{{ earning_growth }}</td>
                          </tr>
                        </table>
                      </template>
                    </profile-card>
                  </div>
                  <div class="md-layout-item md-medium-size-100 mt-0 pt-0 md-size-50">
                    <md-card class="mt-0 pt-0">
                      <md-card-header class="md-card-header-icon pt-0 mt-0">
                        <h5 class="Performance Scores  pt-0 mt-0">Valuation Drivers</h5>
                        <p class="small">
                          While a broad range of factors affects every valuation, the core analysis often relies on three yardsticks: sales volume, sales growth and owner earnings. The larger these factors and the higher their growth, the higher the ultimate business value tends to be. Revenue volume is itself a differentiating factor in determining price multiples, whether Price/Sales or Price/Earnings. In general, multiples tend to increase with firm size on an industry-specific basis. In this case, the subject firm falls into the revenue class A bracket of $ 2.5m. (Multiples are divided into four revenue brackets.) Other key factors include not only Sales and Owner Earnings as current multiples, but also the growth of each, as displayed in the chart: </p>
                      </md-card-header>
                      <md-card-content class="chartHeader mt-0 pt-0 border-0">
                        <LineChart v-if="valuationDriversChartData" :ycolor="'#000'" :xcolor="'#000'" :height="'250px'" :categories="valuationDriversChartData.labels" :chartdata="valuationDriversChartData.series"/>
                      </md-card-content>
                    </md-card>
                  </div>
                </div>
                <!-- </md-card-content> -->
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page5" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="overall_score page">
              <div class="section_body">
                <!-- <md-card-header class="md-card-header-icon">
                            </md-card-header> -->
                <!-- <md-card-content> -->
                <div class="md-layout">
                  <div class="md-layout-item md-medium-size-100 md-size-50">
                    <template slot="header">
                      <h5 class="Performance Scores card-title m-0">Historial Vestimate Business Values</h5>
                    </template>
                    <profile-card header-color="blue" class="table-card no-header">
                      <template slot="content">
                        <!-- <h4 class="Performance Scores"> Historial Vestimate Business Values</h4> -->
                        <!-- <div class="extra_space"> -->
                        <!--<p>
                                                Because the absence of legacy year growth
                                                analysis, growth metrics are not included in the
                                                value trend analysis for prior years. Current
                                                year value may reflect additional active year
                                                values and integrated KPIs selected by the
                                                developer. As a result, the historical values
                                                here may not represent a 100% apples-to-apples
                                                comparison.
                                            </p>-->
                        <h5 class="table_header mt-0">Final Vestimate Pro Values</h5>
                        <table v-if="vestimateReport && vestimateReport.vestimate" class="table1">
                          <tr>
                            <td>Earnings Approach:</td>
                            <td>
                              {{
                                this.vestimateReport.vestimate.earnings
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td>Sale Approach:</td>
                            <td>{{ this.vestimateReport.vestimate.income }}</td>
                          </tr>
                        </table>
                        <!-- </div> -->
                      </template>
                    </profile-card>
                    <profile-card header-color="blue" class="table-card no-header mt-0">
                      <template slot="content">
                        <!-- <div class="extra_space"> -->
                        <h5 class="table_header mt-0">Historical Trend Values (excludes growth KPIs)</h5>
                        <table class="table">
                          <tr v-for="earning in historical_earnings" :key="earning.id">
                            <td class="nowrap">{{ earning.year }} Asset Sale Value:</td>
                            <td>Earnings Approach</td>
                            <td>{{ earning.value }}</td>
                          </tr>
                          <tr v-for="income in historical_income" :key="income.id">
                            <td class="nowrap">{{ income.year }} Asset Sale Value:</td>
                            <td>Sale Approach:</td>
                            <td>{{ income.value }}</td>
                          </tr>
                        </table>
                        <!-- </div> -->
                      </template>
                    </profile-card>
                  </div>
                  <div class="md-layout-item md-medium-size-100 md-size-50">
                    <md-card-header class="md-card-header-icon mt-0 pt-0 pb-0">
                      <h5 class="Performance Scores">{{ vestimateReport.IF.timeSeries }} Historical Value Trend</h5>
                      <p class="small">
                        These factors are analyzed along with a scored set of financial metrics to develop final Vestimate-Pro business values. Firm financial data is benchmarked against industry peer group values for up to three years, depending on inputs. While all three years of industry data are displayed, only those years for which firm inputs were developed are shown and used in Vestimate-Pro calculations. </p>
                    </md-card-header>
                    <md-card-content class="chartHeader border-0">
                      <LineChart v-if="historicalValueChartData && valuationDriversChartData && valuationDriversChartData.series.length > 3" :ycolor="'#000'" :xcolor="'#000'" :height="'250px'" :categories="historicalValueChartData.labels" :chartdata="historicalValueChartData.series"/>
                    </md-card-content>
                  </div>
                </div>
                <!-- </md-card-content> -->
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page6" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="overall_score page">
              <div class="section_body">
                <div class="section_title">
                  <h2>SCORE</h2>
                  <!--<span class="date">Feb 3rd 2022</span>-->
                </div>
                <div class="md-layout pt-4 mt-4 md-alignment-center">
                  <div class="md-layout-item md-size-40">
                    <div class="score_circle">
                      <div class="inner_circle">
                        <h2>
                          Overall Score </h2>
                        <div class="score" v-if="this.average">{{ this.average }}/5
                        </div>
                        <div class="score" v-if="!this.average">N/A</div>
                      </div>
                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="300px" height="300px">
                        <defs>
                          <linearGradient id="GradientColor">
                            <stop offset="10%" stop-color="#00BEF9"/>
                            <stop offset="100%" stop-color="#6A28EA"/>
                          </linearGradient>
                        </defs>
                        <circle cx="150" cy="150" r="135" stroke-linecap="round" fill="none" stroke-width="30px" stroke="url(#GradientColor)" :stroke-dasharray="this.average"/>
                      </svg>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-60 p-0">
                    <h3>KPI Scores</h3>
                    <p>Tabulated results from these KPIs are integrated into Vestimate value calculations. Detailed tables and charts supporting these scores can be found in sections IV and V.</p>
                    <div class="md-layout score">
                      <div class="md-layout-item md-size-100">
                        <h5 class="table_header">Cash Flow:</h5>
                        <table v-if="this.score">
                          <tr>
                            <td>
                              Current Ratio: {{
                                this.score['Current Ratio']['KPI']
                                    ? this.score['Current Ratio'][
                                        'KPI'
                                        ]
                                    : ''
                              }}
                              <div v-if="this.score['Current Ratio']['KPI'] === 'n/a'" class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(this.score['Current Ratio']['KPI'])" :key="i">{{ v }}</md-icon>
                              </div>
                            </td>
                            <td>
                              Days Payable: {{
                                this.score['Days Payable']['KPI']
                                    ? this.score['Days Payable'][
                                        'KPI'
                                        ]
                                    : ''
                              }}
                              <div v-if="this.score['Days Payable']['KPI'] === 'n/a'" class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(this.score['Days Payable']['KPI'])" :key="i">{{ v }}</md-icon>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="md-layout pt-4 mt-4">
                  <div class="md-layout-item md-size-100 p-0">
                    <div class="md-layout score">
                      <div class="md-layout-item md-size-66 mb-4">
                        <h5 class="table_header">Profitability:</h5>
                        <table class="table1" v-if="this.score">
                          <tr>
                            <td>
                              Owner Earnings: {{
                                this.score['Owner Earnings']['KPI']
                                    ? this.score['Owner Earnings'][
                                        'KPI'
                                        ]
                                    : ''
                              }}
                              <div v-if="
                                                            this.score['Owner Earnings'][
                                                            'KPI'
                                                            ] === 'n/a'
                                                        " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                            this.score['Owner Earnings'][
                                                            'KPI'
                                                            ]
                                                            )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                            <td>
                              Owner Earnings Growth: {{
                                this.score['Owner Earnings Growth'][
                                    'KPI'
                                    ]
                                    ? this.score[
                                        'Owner Earnings Growth'
                                        ]['KPI']
                                    : ''
                              }}
                              <div v-if="
                                                            this.score[
                                                            'Owner Earnings Growth'
                                                            ]['KPI'] === 'n/a'
                                                        " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                            this.score[
                                                            'Owner Earnings Growth'
                                                            ]['KPI']
                                                            )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                            <td>
                              Sales Growth: {{
                                this.score['Sales Growth']['KPI']
                                    ? this.score['Sales Growth'][
                                        'KPI'
                                        ]
                                    : ''
                              }}
                              <div v-if="
                                                            this.score['Sales Growth'][
                                                            'KPI'
                                                            ] === 'n/a'
                                                        " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                            this.score['Sales Growth'][
                                                            'KPI'
                                                            ]
                                                            )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                            <td>
                              Return on Assets: {{
                                this.score['Return on Assets'][
                                    'KPI'
                                    ]
                                    ? this.score['Return on Assets'][
                                        'KPI'
                                        ]
                                    : ''
                              }}
                              <div v-if="
                                                            this.score['Return on Assets'][
                                                            'KPI'
                                                            ] === 'n/a'
                                                        " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                            this.score['Return on Assets'][
                                                            'KPI'
                                                            ]
                                                            )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="md-layout-item md-size-33 mb-4">
                        <h5 class="table_header">Efficiency:</h5>
                        <table class="table1" v-if="this.score">
                          <tr>
                            <td>
                              Days Receivable: {{
                                this.score['Days Receivable']['KPI']
                                    ? this.score['Days Receivable'][
                                        'KPI'
                                        ]
                                    : ''
                              }}
                              <div v-if="
                                                                this.score['Days Receivable'][
                                                                'KPI'
                                                                ] === 'n/a'
                                                            " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                                this.score['Days Receivable'][
                                                                'KPI'
                                                                ]
                                                                )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                            <td>
                              Efficiency Index: {{
                                this.score['Efficiency Index'][
                                    'KPI'
                                    ]
                                    ? this.score['Efficiency Index'][
                                        'KPI'
                                        ]
                                    : ''
                              }}
                              <div v-if="
                                                                this.score['Efficiency Index'][
                                                                'KPI'
                                                                ] === 'n/a'
                                                            " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                                this.score['Efficiency Index'][
                                                                'KPI'
                                                                ]
                                                                )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="md-layout-item md-size-66 mb-4">
                        <h5 class="table_header">Debt-Risk:</h5>
                        <table class="table1" v-if="this.score">
                          <tr>
                            <td>
                              Modified Z-Score: {{
                                this.score['Modified Z-Score'][
                                    'KPI'
                                    ]
                                    ? this.score['Modified Z-Score'][
                                        'KPI'
                                        ]
                                    : ''
                              }}
                              <div v-if="
                                                                this.score['Modified Z-Score'][
                                                                'KPI'
                                                                ] === 'n/a'
                                                            " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                                this.score['Modified Z-Score'][
                                                                'KPI'
                                                                ]
                                                                )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                            <td>
                              Interest Coverage: {{
                                this.score['Interest Coverage'][
                                    'KPI'
                                    ]
                                    ? this.score['Interest Coverage'][
                                        'KPI'
                                        ]
                                    : ''
                              }}
                              <div v-if="
                                                                this.score['Interest Coverage'][
                                                                'KPI'
                                                                ] === 'n/a'
                                                            " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                                this.score['Interest Coverage'][
                                                                'KPI'
                                                                ]
                                                                )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                            <td>
                              Total Liabilities: Net Worth: {{
                                this.score[
                                    'Total Liabilities to Net Worth'
                                    ]['KPI']
                                    ? this.score[
                                        'Total Liabilities to Net Worth'
                                        ]['KPI']
                                    : ''
                              }}
                              <div v-if="
                                                                this.score[
                                                                'Total Liabilities to Net Worth'
                                                                ]['KPI'] === 'n/a'
                                                            " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                                this.score[
                                                                'Total Liabilities to Net Worth'
                                                                ]['KPI']
                                                                )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="md-layout-item md-size-33 mb-4">
                        <h5 class="table_header">Market Opportunity:</h5>
                        <table class="table1" v-if="this.score">
                          <tr>
                            <td>
                              Market Opportunity Index: {{
                                this.score['Market Opportunity'][
                                    'KPI'
                                    ]
                                    ? this.score[
                                        'Market Opportunity'
                                        ]['KPI']
                                    : ''
                              }}
                              <div v-if="
                                                                this.score['Market Opportunity'][
                                                                'KPI'
                                                                ] === 'n/a'
                                                            " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                                this.score[
                                                                'Market Opportunity'
                                                                ]['KPI']
                                                                )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                            <td>
                              Industry Market Growth: {{
                                this.score[
                                    'Industry Market Growth'
                                    ]['KPI']
                                    ? this.score[
                                        'Industry Market Growth'
                                        ]['KPI']
                                    : ''
                              }}
                              <div v-if="
                                                                this.score[
                                                                'Industry Market Growth'
                                                                ]['KPI'] === 'n/a'
                                                            " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                                this.score[
                                                                'Industry Market Growth'
                                                                ]['KPI']
                                                                )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page7" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="overall_score page">
              <div class="section_body">
                <div class="md-layout pt-4 mt-4">
                  <div class="md-layout-item md-size-100 p-0">
                    <h3>OTHER VALUE INDICATORS</h3>
                    <div class="md-layout score">
                      <div class="md-layout-item md-size-50 mb-4">
                        <h4 class="heading-md">Assess the age, loyalty, training, experience and motivation of the workforce.</h4>
                        <h5 class="table_header">Higher is better:</h5>
                        <table v-if="this.score">
                          <tr>
                            <td>
                              Key Employees: {{
                                this.score['Key Employees']['KPI']
                                    ? this.score['Key Employees'][
                                        'KPI'
                                        ]
                                    : ''
                              }}
                              <div v-if="
                                                            this.score['Key Employees'][
                                                            'KPI'
                                                            ] === 'n/a'
                                                            " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                                this.score['Key Employees'][
                                                                'KPI'
                                                                ]
                                                            )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="md-layout-item md-size-50 mb-4">
                        <h4>Is customer stability seasonal with low repeat sales or year round with high repeat levels?</h4>
                        <h5 class="table_header">Higher is better: not seasonal/more repeat sales.</h5>
                        <table v-if="this.score">
                          <tr>
                            <td>
                              Customer Base: {{
                                this.score['Customer Base']['KPI']
                                    ? this.score['Customer Base'][
                                        'KPI'
                                        ]
                                    : ''
                              }}
                              <div v-if="
                                                                this.score['Customer Base'][
                                                                'KPI'
                                                                ] === 'n/a'
                                                            " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                                this.score['Customer Base'][
                                                                'KPI'
                                                                ]
                                                                )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="md-layout-item md-size-50 mb-4">
                        <h4>Are technology practices up to date?</h4>
                        <h5 class="table_header">How do they compare with competitors? Higher is better.</h5>
                        <table v-if="this.score">
                          <tr>
                            <td>
                              Technology Level: {{
                                this.score['Technology Level'][
                                    'KPI'
                                    ]
                                    ? this.score['Technology Level'][
                                        'KPI'
                                        ]
                                    : ''
                              }}
                              <div v-if="
                                                                this.score['Technology Level'][
                                                                'KPI'
                                                                ] === 'n/a'
                                                            " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                                this.score['Technology Level'][
                                                                'KPI'
                                                                ]
                                                                )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="md-layout-item md-size-50 mb-4">
                        <h4>Do the top 5 customers account for >25% of revenue; or does any one</h4>
                        <h5 class="table_header">customer account for >10%? Higher (less concentration) is better.</h5>
                        <table v-if="this.score">
                          <tr>
                            <td>
                              Customer Concentration: {{
                                this.score[
                                    'Customer Concentration'
                                    ]['KPI']
                                    ? this.score[
                                        'Customer Concentration'
                                        ]['KPI']
                                    : ''
                              }}
                              <div v-if="
                                                                this.score[
                                                                'Customer Concentration'
                                                                ]['KPI'] === 'n/a'
                                                            " class="star_rating">
                                <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                              </div>
                              <div v-else class="star_rating">
                                <md-icon v-for="(v, i) in getStars(
                                                                this.score[
                                                                'Customer Concentration'
                                                                ]['KPI']
                                                                )" :key="i">{{ v }}
                                </md-icon>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer pt-4">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>



          <section v-if="this.vestimateReport.context_text.context_history !== '' || this.vestimateReport.context_text.context_operations !== ''" ref="companyContext" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="covid-sec page">
              <div class="section_body">
                <div class="section_title mb-4">
                  <h2>Company Context</h2>
                </div>
                <div v-if="this.vestimateReport.context_text.context_history !== ''" class="md-layout mb-4">
                  <div class="md-layout-item md-size-100 p-0 if-prfl">
                    <div class="md-card-header card-heading-md"><h3>Company History</h3></div>
                    <div class="tbl-wht-box p-4 light_border">
                      <p>{{ this.vestimateReport.context_text.context_history }}</p>
                    </div>
                  </div>
                </div>
                <div v-if="this.vestimateReport.context_text.context_operations !== ''" class="md-layout mb-4">
                  <div class="md-layout-item md-size-100 p-0 if-prfl">
                    <div class="md-card-header card-heading-md"><h3>Company Operations</h3></div>
                    <div class="tbl-wht-box p-4 light_border">
                      <p>{{ this.vestimateReport.context_text.context_operations }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer pt-4">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>

          <section v-if="this.vestimateReport.context_text.context_products !== ''" ref="companyContext_prod" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="covid-sec page">
              <div class="section_body">
                <div class="section_title mb-4">
                  <h2>Company Context</h2>
                </div>
                <div v-if="this.vestimateReport.context_text.context_products !== ''" class="md-layout mb-4">
                  <div class="md-layout-item md-size-100 p-0 if-prfl">
                    <div class="md-card-header card-heading-md"><h3>Company Products</h3></div>
                    <div class="tbl-wht-box p-4 light_border">
                      <p>{{ this.vestimateReport.context_text.context_products }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer pt-4">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>


          <section ref="page8" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="covid-sec page">
              <div class="section_body">
                <div class="section_title mb-4">
                  <h2>Market Environment</h2>
                  <span class="date">Feb 3rd 2022</span>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 p-0 if-prfl">
                    <div class="md-card-header card-heading-md"><h3>Market Population Demographics</h3></div>
                    <div class="tbl-wht-box p-4 light_border">
                      <p>
                        The {{ this.companyName ? this.companyName : "Company" }} competitive industry market area analysis is based on the {{ !this.vestimateReport.all_us ? this.vestimateReport.MR.area : "US Market Area" }}. Total population in the market area is {{ this.vestimateReport.MR['measures']['Population'] }} in {{ this.vestimateReport.MR['measures']['Households'] }} households with a median age of {{ this.vestimateReport.MR['measures']['Median Age'] }}. The adult age breakdown is: Millennials (20-34): {{ this.vestimateReport.MR['measures']['Millennials'] }}; Gen Xers (35-54): {{ this.vestimateReport.MR['measures']['Genx'] }}; Boomers (55-74): {{ this.vestimateReport.MR['measures']['Boomers'] }}.
                        <br/>
                        <br/> {{ this.vestimateReport.MR['measures']['Bachelors'] }} of the population boasts a bachelor’s degree or higher; another {{ this.vestimateReport.MR['measures']['Associate'] }} holds an associate degree.
                        <br/>
                        <br/> Median housing value in the market area is {{ this.vestimateReport.MR['measures']['Median Household Value'] }}, while the median rent level is {{ this.vestimateReport.MR['measures']['Median Rent'] }} per month. Per capita income in the market area is {{ this.vestimateReport.MR['measures']['Per Capita Income'] }}, while average (mean) household income is {{
                          this.vestimateReport.MR['measures']['Mean HH income']
                        }} and median household income is {{ this.vestimateReport.MR['measures']['Median HH Income'] }}. 27.84% of market area households earn over one hundred thousand dollars per year.
                      </p>
                    </div>
                  </div>
                  <div class="md-layout-item mb-4 p-0">
                    <h3 class="sub_header mt-4">Industry Market Benchmarks</h3>
                    <md-table v-model="VRIndustryMarketBenchmarks" table-header-color="blue" class="profit-and-loss-table table-compact">
                      <md-table-row>
                        <md-table-head></md-table-head>
                        <md-table-head>INDUSTRY</md-table-head>
                        <md-table-head></md-table-head>
                        <md-table-head></md-table-head>
                        <md-table-head>FIRM</md-table-head>
                        <md-table-head></md-table-head>
                        <md-table-head></md-table-head>
                      </md-table-row>
                      <md-table-row v-for="item in VRIndustryMarketBenchmarks" :key="item.id">
                        <md-table-cell md-label="">
                          <div class="md-table-side-label">
                            {{ item.benchmark }}
                          </div>
                        </md-table-cell>
                        <md-table-cell v-for="(key,i) in Object.keys(item.industry)" :key="'industry_'+i">
                          {{ item.industry[key] }}
                        </md-table-cell>
                        <md-table-cell v-for="(key,j) in Object.keys(item.firm)" :key="'firm_'+j">
                          {{ item.firm[key] }}
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page9" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="covid-sec page">
              <div class="section_body">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 p-0 if-prfl">
                    <div class="md-card-header"><h3>Industry Market Context</h3></div>
                    <div class="tbl-wht-box p-4 light_border">
                      <p>
                        In this market area, the {{ this.industryName }} industry includes {{ this.vestimateReport.MR['measures']['Industry Operations'] }} operations; {{ this.vestimateReport.MR['measures']['Firms'] }} independent firms and {{ this.vestimateReport.MR['measures']['Branches'] }} branch establishments. Among the independent firms, {{ this.vestimateReport.MR['measures']['Small Businesses'] }} fall within the small business definition of single site firms with fewer than twenty-five employees. Total industry employment is ${{ this.numberWithComma(this.vestimateReport.MR['measures']['Employment']) }}. Of these, {{ this.numberWithComma(this.vestimateReport.MR['measures']['SB Employment']) }} are employed in small business operations of fewer than 25 employees. The average industry operation has {{ this.vestimateReport.MR['measures']['Average Employment'] }} employees. </p>
                      <p>
                        In {{ this.vestimateReport.IF['ifDataYears'][this.vestimateReport.last_year_index] }}, industry operations in the market area accounted for a total market volume of {{ this.vestimateReport.MR['measures']['Annual Market Sales Volume'] }}. Of that, the industry market small business segment accounts for {{ this.vestimateReport.MR['measures']['SB Market Share Volume'] }} in sales. The small business share of the total market has {{
                          this.vestimateReport.MR['measures']['SB Market Share text']
                        }} from {{ this.vestimateReport.MR['measures']['SB Market Share Year 1'] }} to {{ this.vestimateReport.MR['measures']['SB Market Share Year 3'] }} since {{ this.vestimateReport.IF['ifDataYears'][0] }}.<br/> Most recent annual {{ this.companyName ? this.companyName : "Company" }} sales are ${{
                          this.numberWithComma(this.vestimateReport.input_structure.IFInputs[this.vestimateReport.recentYear]['revenue']['value'])
                        }}. By contrast, average annual industry site sales are {{ this.vestimateReport.MR['measures']['Average Site Sales'] }}. Median site sales are {{ this.vestimateReport.MR['measures']['Median Site Sales'] }}. Market area small business sales average {{ this.vestimateReport.MR['measures']['Average Small Business Sales'] }}. Average annual industry site sales have {{
                          this.vestimateReport.MR['measures']['Avg Site Sale Change'].replace("%", "") > 0 ? "decreased" : "increased"
                        }} by {{ this.vestimateReport.MR['measures']['Avg Site Sale Change'].replace("-", "") }} in the three calendar years {{ this.vestimateReport.IF['ifDataYears'][0] }} to {{ this.vestimateReport.IF['ifDataYears'][this.vestimateReport.last_year_index] }}; market area average small business sales {{ this.vestimateReport.MR['measures']['Avg SB Sale Change Text'] }} by {{ this.vestimateReport.MR['measures']['Avg SB Sale Change'] }} during the same period.
                      </p><p>
                      {{ this.companyName ? this.companyName : "Company" }} sales rank {{ this.vestimateReport.calculations['sales_rank'] }} industry operations in the market area—a percentile rating of {{ this.vestimateReport.calculations['sales_rank_percentile'] }}. {{ this.companyName ? this.companyName : "Company" }} holds a {{ this.vestimateReport.MR['measures']['Film Market Share'] }} share of market sales, which {{ this.vestimateReport.MR['measures']['Firm Market Share Text'] }} percentage points since {{ this.vestimateReport.IF['ifDataYears'][0] }}.
                      <span v-if="this.vestimateReport.MR['penetration']['US Sales per Person']">
                                            The {{
                          this.industryName
                        }} industry captures {{ this.vestimateReport.MR['penetration']['US Sales per Person'] }} in sales per person
                                            at the national level{{
                          !this.vestimateReport.all_us ? ", while market area sales per person is " + this.vestimateReport.MR['penetration']['Market Sales per Person'] : ""
                        }}. US industry sales per household are
                                            {{ this.vestimateReport.MR['penetration']['US Sales per Household'] }}.
                                                <span v-if="!this.vestimateReport.all_us">
                                                By contrast, market area sales per household are calculated at {{
                                                    this.vestimateReport.MR['penetration']['Market Sales per Household']
                                                  }}.
                                                </span>

                                            This and related
                                            indicators (e.g., Sales per Person or Sales per
                                            Business Establishment) may suggest whether the {{
                          !this.vestimateReport.all_us ? "local" : ""
                        }}
                                            industry market is saturated or under‐served,
                                            reflecting opportunities for firm expansion or growth.
                                            Only one or two of these metrics may be relevant to
                                            the specific industry or firm, depending on its
                                            customer target. This valuation does not include a
                                            calculated Sales per Household score in the case of
                                            most B-to-B industries.
                                            {{
                          !this.vestimateReport.all_us ? "Where a local market has been selected, the sales per household variance is applied as a Market Opportunity Index metric to value calculations." : ""
                        }}

                                            </span><p/><p>
                      {{ this.vestimateReport.MR['measures']['Startups'] }} independent industry startups and new branch operations were identified in the market area at the end of {{ this.vestimateReport.IF['ifDataYears'][this.vestimateReport.last_year_index] }}, creating a new operation rate of {{ this.vestimateReport.MR['measures']['Market Industry Startup Rate'] }} in the most recent analysis year {{
                        !this.vestimateReport.all_us ? ", " + this.vestimateReport.MR['measures']['Industry Startup Rate Text'] + " than the national industry rate of " + this.vestimateReport.MR['measures']['US Industry Startup Rate'] : ""
                      }}. Unusually low new operation rates can indicate market saturation or lack of perceived opportunity, while high rates suggest both opportunity and the recognition of it. </p>
                      <p>
                        Over {{ this.vestimateReport.IF['ifDataYearsFull'][1] }} - {{ this.vestimateReport.IF['ifDataYearsFull'][2] }}, {{ this.vestimateReport.MR['measures']['Cessation'] }} of industry establishments in this market area ceased operation. {{
                          !this.vestimateReport.all_us ? "US industry cessation rates were " + this.vestimateReport.MR['measures']['Cessation US'] : ""
                        }}. </p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page10" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="about_info approach page">
              <div class="section_body">
                <div class="section_title mb-4">
                  <h2>Valuation Approach</h2>
                  <span class="date">Feb 3rd 2022</span>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 p-0 mb-4">
                    <h3 class="sub_header mt-0">General</h3>
                    <p>Bizminer Vestimate-Pro reports help you understand the value of any firm simply and quickly. No other electronic valuation tool organizes critical information with the level of data integrity and industry detail that results from the integration of Bizminer’s widely-recognized industry financial and market analysis content and its derivative analysis of 30,000 recent business transactions from the DealStats database. Both the Bizminer and DealStats datasets are key components in the analytical toolbox of thousands of certified business valuation professionals. Vestimate-Pro data sources are distinct and transparent; our financial analysis is utilized by thousands of accounting, valuation, banking and business assistance professionals; by almost one hundred university libraries and by taxing agencies in multiple countries. You won’t find a lot of jargon and overblown claims in our Vestimate-Pro Business Value Reports —just the hard analysis and clear answers you need. Vestimate-Pro analytical content is updated regularly using the same tested protocols applied to our Industry Market Trend reports, which cover over 9000 industry classifications; and to the trusted industry financial analysis we present for more than 5000 lines of business. Uniquely among published electronic value calculations, the Vestimate-Pro analysis integrates traditional financial metrics with market opportunity and growth analyses from Bizminer’s recognized Industry Market dataset. Your Vestimate-Pro report includes definitions of every line item and ratio, as well as a simple scoring interface that compares your firm’s performance to the industry peer group. When you accessed your Vestimate-Pro Report, you chose a comparison peer group that most closely represents the character of your firm. Your peer group is defined by a series of criteria that reflects your selections of:</p>
                    <div class="list_box p-4">
                      <ul>
                        <li>Industry Segment: [{{ parseFloat(this.headerData.bznaics) }}] {{ this.headerData.industry }}</li>
                        <li>Market Analysis Area: {{ this.headerData.area }}</li>
                        <li>Sales Class:{{ this.headerData.sales_class }}</li>
                      </ul>
                    </div>
                    <p>This report is additionally conditioned by the selection and active integration of 3 of three potential years of firm inputs. While the Vestimate-Pro report offers integrated scoring of 13 financial and market KPIs, only those scored on P4 were selected by the developer for activation. The Vestimate-Pro report is an informational tool, not a guide to action. Do not use the report in place of a certified valuation, or as the basis of any specific business-related or other financial transaction. For that we recommend obtaining an appraisal from a business broker, a valuation from a certified valuation professional, or both. You should not attempt to use Vestimate-Pro to secure a business or personal loan. Be aware that the Vestimate-Pro report may not consider market or firm idiosyncrasies that can influence the actual value or selling price.</p>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page11" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="about_info approach page">
              <div class="section_body">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 p-0 mb-4">
                    <h3 class="sub_header">Business Value Approaches</h3>
                    <p>Vestimate-Pro reports develop both "asset sale" and "equity sale" values for earnings and revenue approach valuation methods. These approaches are coupled with benchmarks for key financial ratios and market metrics which compare the analyzed firm’s liquidity, profitability, efficiency, debt-risk performance and market opportunity to industry peer group standards. The result is a meaningful analysis and final value estimates that make sense in the real world, providing useful information to valuation professionals, brokers, sellers, entrepreneurs, investors and advisors.</p>
                  </div>
                  <div class="md-layout-item md-size-100 p-0 mb-4">
                    <h3 class="sub_header">Your Industry in Context: The NAICS Classification System</h3>
                    <p>The industry you selected fits within the official NAICS (North American Industry Classification System) and Bizminer's proprietary taxonomy, which breaks out more detailed industries classifications than the NAICS by adding up to eight decimal digits after the NAICS-6 code. The selected industry fits into this hierarchy:
                    <p>
                    <div class="list_box p-4">
                      <ul>
                        <li v-for="item in this.industryRollup" :key="item">{{ item }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page12" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="about_info approach page">
              <div class="section_body">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 p-0 mb-4">
                    <h3 class="sub_header">Ratio Categories</h3>
                    <p>The Vestimate-Pro Business Value Report benchmarks pivotal industry peer group financial ratio values against the performance of your firm, then integrates the results into the overall analysis and calculations. These ratios (also known as KPIs or Key Performance Indicators) fall into five categories:
                    <p>
                    <div class="list_box p-4">
                      <ul>
                        <li>Cash Flow/Solvency:
                          <p>Cash Flow ratios indicate a company's ability to meet various levels of demand on cash and easily obtainable cash resources against current and anticipated near-term payments due.</p>
                        </li>
                        <li>Profitability:
                          <p>Profitability ratios compare levels of return against various expense and balance sheet components to measure your performance against reasonable industry peer group standards, indicating bottom line performance.</p>
                        </li>
                        <li>Efficiency:
                          <p>Efficiency ratios measure your success in marshalling resources-at-hand to effectively manage various components of your business operations. These indicators often point toward specific actions that could enhance your bottom line.</p>
                        </li>
                        <li>Debt-Risk:
                          <p>Debt-Risk ratios assess the appropriateness of a firm's level of debt against the ability to pay, as well as the risk of insolvency.</p>
                        </li>
                        <li>Market Opportunity:
                          <p>These non-traditional financial metrics assess overall market vitality and opportunity.</p>
                        </li>
                      </ul>
                    </div>
                    <p>Depending on subject firm inputs you make, the ratios will be scored against industry values for up to three recent calendar years.<br/>Financial ratios are calculated for the subject firm when you submit the necessary inputs. Firm ratio benchmarks are scored on a 1-5 scale based on their variance from industry peer group standards. While the report presents starred scores for ease of display, final value calculations are more finely calibrated and applied based on each percentage point of variance from the industry norm. For more details, see About the Data—Our Approach to Scoring.
                    </p>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="industryAnalysis" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="covid-sec page">
              <div class="section_body">
                <div class="section_title mb-4">
                  <h2>Industry Financial Analysis</h2>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item mb-4 p-0">
                    <h3 class="sub_header">Percentages</h3>
                    <md-table v-model="PercentagesFinancialAnalysis" table-header-color="blue" class="profit-and-loss-table">
                      <md-table-row>
                        <md-table-head></md-table-head>
                        <md-table-head colspan="3">INDUSTRY</md-table-head>
                        <md-table-head colspan="3">{{ this.client.client_name ? this.client.client_name : 'FIRM' }}</md-table-head>
                      </md-table-row>
                      <md-table-row v-for="item in PercentagesFinancialAnalysis" :key="item.id">
                        <md-table-cell md-label="Parameters">
                          {{ item.name }}
                        </md-table-cell>
                        <md-table-cell v-for="key in Object.keys(item.industry)" :md-label="key" :key="'industry_' + key">{{ item.industry[key] }}</md-table-cell>
                        <md-table-cell v-for="key in Object.keys(item.firm)" :md-label="key" :key="'firm_' + key">{{
                            item.firm[key]
                          }}
                        </md-table-cell>
                      </md-table-row>
                      <md-table-row></md-table-row>
                    </md-table>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="industryAnalysisDollars" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="covid-sec page">
              <div class="section_body">
                <div class="section_title mb-4">
                  <h2>Industry Financial Analysis</h2>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item mb-4 p-0">
                    <h3 class="sub_header mt-4">Dollars</h3>
                    <md-table v-model="DollarsFinancialAnalysis" table-header-color="blue" class="hdlessTable">
                      <md-table-row class="tableHead">
                        <md-table-head></md-table-head>
                        <md-table-head colspan="3">INDUSTRY</md-table-head>
                        <md-table-head colspan="3">{{ this.client.client_name ? this.client.client_name : 'FIRM' }}</md-table-head>
                      </md-table-row>
                      <md-table-row v-for="item in DollarsFinancialAnalysis" :key="item.id">
                        <md-table-cell md-label="Parameters">
                          {{ item.name }}
                        </md-table-cell>
                        <md-table-cell :hidden="checkNameAnalysis(item,'industry',key)" v-for="key in Object.keys(item.industry)" :key="'industry_' + key" :md-label="key">{{ item.industry[key] }}</md-table-cell>
                        <md-table-cell :hidden="checkNameAnalysis(item,'firm',key)" v-for="key in Object.keys(item.firm)" :key="'firm_' + key" :md-label="key">{{
                            item.firm[key]
                          }}
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="industryAnalysisVariance" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="covid-sec page">
              <div class="section_body">
                <div class="section_title mb-4">
                  <h2>Industry Financial Analysis</h2>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item mb-4 p-0">
                    <h3 class="sub_header mt-4">Variance</h3>
                    <md-table v-model="VarianceFinancialAnalysis" table-header-color="blue" class="profit-and-loss-table">
                      <md-table-row v-if="item.name" slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell :md-label="VarianceFinancialAnalysisAux[0].name" md-table="Parameters" class="md-table-side-label">{{ item.name }}
                        </md-table-cell>
                        <md-table-cell :hidden="checkNameAnalysis(item,'variance',key)" v-for="key in Object.keys(item.dates)" :md-label="key" :key="key">{{
                            item.dates[key]
                          }}
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page13" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="kpi-details-info if-prfl page">
              <div class="section_body">
                <div class="md-layout">
                  <h2>KPI Details</h2>
                </div>
                <div class="summary md-layout">
                  <h3>Summary</h3>
                  <div class="info_content">
                    <div class="md-card-header"><h3>Introduction</h3></div>
                    <div class="tbl-wht-box p-4 light_border">
                      <p>
                        To better understand your company’s operations, the Vestimate-Pro Report calculates Key Performance Indicators (KPIs) for review and comparison to industry benchmarks. KPIs (also known as financial ratios) are calculated on the basis of company-specific data linked to the corresponding values of the selected industry peer group. These and other derivative metrics that form the basis of our analysis are developed from a variety of raw data sources detailed in the Methodology section of this report.</p>
                      <p>KPls are useful measures of the overall financial and operational health and growth of your business. These same measures are commonly utilized by business coaches, financial professionals and potential business acquirers in a variety of real world settings. The Vestimate-Pro report applies KPI scoring to the calculation of business worth as variance-based values to which various weights are assigned based on the specific metric, years of inputs and variance.</p>
                      <p>In addition to detailing KPI variances and applying a calibrated weight to each percent of difference from industry peer group standards, we use an intuitive five-star scoring system to communicate firm performance against industry peer group standards. Except for Days Payable and Days Receivable, KPIs are scored on a “higher is better” basis. The scoring approach is also detailed in the About the Data>Methodology section (VII) of this report. </p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page14" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="kpi-details-info if-prfl page">
              <div class="summary md-layout p-4">
                <div class="md-layout mt-4 p-4">
                  <div class="summary_info">
                    <div class="md-card-header"><h3>Financial Ratios:</h3></div>
                    <div class="tbl-wht-box p-4 light_border">
                      <p>
                        Weighted KPI values are applied to the value analysis to assure representation in each category. Scores are derived from the variance and growth percentages displayed in the table below and charts on the following pages. KPI charts follow.
                        <strong> This report reflects the developer selection of calendar year values which are weighted as follows:
                          <br/> <span v-if="
                                            this.vestimateReport.yearsVisible.length === 3
                                            ">
                                            3-year Option:
                                            {{ this.vestimateReport.yearsVisible[0] }}: 25%;
                                            {{ this.vestimateReport.yearsVisible[1] }}: 25%;
                                        </span> <span v-else-if="
                                            (this.vestimateReport.yearsVisible.length = 2)
                                            "></span> <span v-else-if="
                                            (this.vestimateReport.yearsVisible.length = 1)
                                            ">
                                            1-year Option:
                                            {{
                              (this.vestimateReport.yearsVisible[0] = this
                                  .vestimateReport.lastYearValue
                                  ? ''
                                  : '')
                            }}: 100%;
                                        </span> </strong>
                      </p>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-100 p-0">
                    <md-table v-model="SummaryFinancialRatios" table-header-color="blue" class="hdlessTable">
                      <md-table-row class="tableHead">
                        <md-table-head></md-table-head>
                        <md-table-head colspan="3">INDUSTRY</md-table-head>
                        <md-table-head colspan="3">{{ this.client.client_name ? this.client.client_name : 'FIRM' }}</md-table-head>
                        <md-table-head colspan="3">VARIANCE</md-table-head>
                      </md-table-row>
                      <md-table-row v-for="item in SummaryFinancialRatios" :key="item.id">
                        <md-table-cell md-label>{{ item.name }}</md-table-cell>
                        <md-table-cell :hidden="checkName(item,'industry',key)" v-for="key in Object.keys(
                                            item.industry
                                            )" :md-label="key" :key="'industry_' + key">{{ item.industry[key] }}
                        </md-table-cell>
                        <md-table-cell :hidden="checkName(item,'firm',key)" colspan="0" v-for="key in Object.keys(item.firm)" :md-label="key" :key="'firm_' + key">{{ item.firm[key] }}</md-table-cell>
                        <md-table-cell :hidden="checkName(item,'variance',key)" v-for="key in Object.keys(
                                            item.variance
                                            )" :md-label="key" :key="'variance_' + key">{{ item.variance[key] }}
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page15" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="kpi-details-info if-prfl page">
              <div class="section_body">
                <div class="Cash-Flow-Solvency">
                  <div class="md-card-header"><h3>Cash Flow-Solvency</h3></div>
                  <div class="tbl-wht-box p-4 light_border">
                    <div class="md-layout p-4">
                      <div class="md-layout-item md-medium-size-100 md-size-50 mb-2">
                        <div class="chart-header">
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Current Ratio ({{ this.vestimateReport.IF.timeSeries }}):</div>
                          </h4>
                          <div v-if="this.vestimateReport.IF.scores['Current Ratio']['KPI'] && this.vestimateReport.IF.scores['Current Ratio']['KPI'] === 'n/a'" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                          </div>
                          <div v-else-if="this.vestimateReport.IF.scores['Current Ratio']['KPI']" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Current Ratio']['KPI'])" :key="i">{{ v }}</md-icon>
                          </div>
                        </div>
                        <LineChart v-if="currentRatioChartData" :ycolor="'#000'" :xcolor="'#000'" :height="'250px'" :categories="currentRatioChartData.labels" :chartdata="currentRatioChartData.series"/>
                        <div class="chart-footer">
                          <p>
                            Current Assets/Current Liabilities: Measures current assets available to cover current liabilities, a test of near-term solvency. The Current Ratio indicates the extent to which cash on hand and disposable assets can pay off near term liabilities. Higher is better unless it constrains necessary investment. </p>
                        </div>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50 mb-2">
                        <div class="chart-header">
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Days Payable ({{ this.vestimateReport.IF.timeSeries }})</div>
                          </h4>
                          <div v-if="this.vestimateReport.IF.scores['Days Payable']['KPI'] && this.vestimateReport.IF.scores['Days Payable']['KPI'] === 'n/a'" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                          </div>
                          <div v-else-if="this.vestimateReport.IF.scores['Days Payable']['KPI']" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Days Payable']['KPI'])" :key="i">{{ v }}</md-icon>
                          </div>
                        </div>
                        <LineChart v-if="daysPayableChartData" :ycolor="'#000'" :xcolor="'#000'" :height="'250px'" :categories="daysPayableChartData.labels" :chartdata="daysPayableChartData.series"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page16" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="kpi-details-info if-prfl page">
              <div class="section_body">
                <div class="profitability-KPIs">
                  <div class="md-card-header"><h3>Profitability KPIs</h3></div>
                  <div data-v-11d45e74="" class="tbl-wht-box light_border">
                    <div class="md-layout">
                      <div class="md-layout-item md-medium-size-100 md-size-50 mb-2">
                        <div class="chart-header">
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Owner Earnings % ({{ this.vestimateReport.IF.timeSeries }})</div>
                          </h4>
                          <div v-if="this.vestimateReport.IF.scores['Owner Earnings']['KPI'] && this.vestimateReport.IF.scores['Owner Earnings']['KPI'] === 'n/a'" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                          </div>
                          <div v-else-if="this.vestimateReport.IF.scores['Owner Earnings']['KPI']" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Owner Earnings']['KPI'])" :key="i">{{ v }}</md-icon>
                          </div>
                        </div>
                        <LineChart v-if="ownerEarningsChartData" :ycolor="'#000'" :xcolor="'#000'" :height="'230px'" :categories="ownerEarningsChartData.labels" :chartdata="ownerEarningsChartData.series"/>
                        <div class="chart-footer">
                          <p>Owner Earnings equals [Officer Compensation+Pre-Tax Net Profit+Depreciation+1x Addbacks]/Revenue.</p>
                        </div>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50 mb-2">
                        <div class="chart-header">
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Owner Earnings Growth ({{ this.vestimateReport.IF.timeSeries }})</div>
                          </h4>
                          <div v-if="this.vestimateReport.IF.scores['Owner Earnings Growth']['KPI'] && this.vestimateReport.IF.scores['Owner Earnings Growth']['KPI'] === 'n/a'" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                          </div>
                          <div v-else-if="this.vestimateReport.IF.scores['Owner Earnings Growth']['KPI']" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Owner Earnings Growth']['KPI'])" :key="i">{{ v }}</md-icon>
                          </div>
                        </div>
                        <LineChart v-if="ownerEarningsGrowthChartData" :ycolor="'#000'" :xcolor="'#000'" :height="'230px'" :categories="ownerEarningsGrowthChartData.labels" :chartdata="ownerEarningsGrowthChartData.series"/>
                        <div class="chart-footer">
                          <p>
                            Compares change in Owner Earnings at the firm and industry levels. Higher multi-year growth in firm-specific owner earnings revenue relative to the US industry average growth is an indicator of accelerated performance. </p>
                        </div>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50 mb-2">
                        <!-- annualSalesGrowthChartData -->
                        <div class="chart-header">
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Annual Sales Growth ({{ this.vestimateReport.IF.timeSeries }})</div>
                          </h4>
                          <div v-if="this.vestimateReport.IF.scores['Sales Growth']['KPI'] && this.vestimateReport.IF.scores['Sales Growth']['KPI'] === 'n/a'" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                          </div>
                          <div v-else-if="this.vestimateReport.IF.scores['Sales Growth']['KPI']" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Sales Growth']['KPI'])" :key="i">{{ v }}</md-icon>
                          </div>
                        </div>
                        <LineChart v-if="annualSalesGrowthChartData" :ycolor="'#000'" :xcolor="'#000'" :height="'230px'" :categories="annualSalesGrowthChartData.labels" :chartdata="annualSalesGrowthChartData.series"/>
                        <div class="chart-footer">
                          <p>
                            Compares change in annual sales at the firm and industry levels. Higher multi-year growth in firm sales relative to national industry annual average growth is an indicator of firm momentum. </p>
                        </div>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50 mb-2">
                        <div class="chart-header">
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Return on Assets ({{ this.vestimateReport.IF.timeSeries }})</div>
                          </h4>
                          <div v-if="this.vestimateReport.IF.scores['Return on Assets']['KPI'] && this.vestimateReport.IF.scores['Return on Assets']['KPI'] === 'n/a'" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                          </div>
                          <div v-else-if="this.vestimateReport.IF.scores['Return on Assets']['KPI']" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Return on Assets']['KPI'])" :key="i">{{ v }}</md-icon>
                          </div>
                        </div>
                        <LineChart v-if="returnOnAssetsChartData" :ycolor="'#000'" :xcolor="'#000'" :height="'230px'" :categories="returnOnAssetsChartData.labels" :chartdata="returnOnAssetsChartData.series"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page17" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="kpi-details-info if-prfl page">
              <div class="section_body">
                <div class="efficiency-KPIs">
                  <div class="md-card-header"><h3>Efficiency KPIs</h3></div>
                  <div class="tbl-wht-box light_border">
                    <div class="md-layout">
                      <div class="md-layout-item md-medium-size-100 md-size-50 mb-2">
                        <div class="chart-header">
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Days Receivables ({{ this.vestimateReport.IF.timeSeries }})</div>
                          </h4>
                          <div v-if="this.vestimateReport.IF.scores['Days Receivable']['KPI'] && this.vestimateReport.IF.scores['Days Receivable']['KPI'] === 'n/a'" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                          </div>
                          <div v-else-if="this.vestimateReport.IF.scores['Days Receivable']['KPI']" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Days Receivable']['KPI'])" :key="i">{{ v }}</md-icon>
                          </div>
                        </div>
                        <LineChart v-if="daysReceivablesChartData" :ycolor="'#000'" :xcolor="'#000'" :height="'250px'" :categories="daysReceivablesChartData.labels" :chartdata="daysReceivablesChartData.series"/>
                        <div class="chart-footer">
                          <p>
                            365/(Business Revenue/Receivables). Reflects the number of days that receivables are outstanding. Higher than average ratios may indicate a problem in the collection process. Target average or lower. </p>
                        </div>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50 mb-2">
                        <div class="chart-header">
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Efficiency Index ({{ this.vestimateReport.IF.timeSeries }})</div>
                          </h4>
                          <div v-if="this.vestimateReport.IF.scores['Efficiency Index']['KPI'] && this.vestimateReport.IF.scores['Efficiency Index']['KPI'] === 'n/a'" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                          </div>
                          <div v-else-if="this.vestimateReport.IF.scores['Efficiency Index']['KPI']" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Efficiency Index']['KPI'])" :key="i">{{ v }}</md-icon>
                          </div>
                        </div>
                        <LineChart v-if="efficiencyIndexChartData" :ycolor="'#000'" :xcolor="'#000'" :height="'250px'" :categories="efficiencyIndexChartData.labels" :chartdata="efficiencyIndexChartData.series"/>
                        <div class="chart-footer"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page18" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="kpi-details-info if-prfl page">
              <div class="section_body">
                <div class="Debt-Risk-KPIs">
                  <div class="md-card-header"><h3>Debt-Risk KPIs</h3></div>
                  <div class="tbl-wht-box light_border">
                    <div class="md-layout">
                      <div class="md-layout-item md-medium-size-100 md-size-50 mb-2">
                        <div class="chart-header">
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Modified Z-Score ({{ this.vestimateReport.IF.timeSeries }})</div>
                          </h4>
                          <div v-if="this.vestimateReport.IF.scores['Modified Z-Score']['KPI'] && this.vestimateReport.IF.scores['Modified Z-Score']['KPI'] === 'n/a'" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                          </div>
                          <div v-else-if="this.vestimateReport.IF.scores['Modified Z-Score']['KPI']" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Modified Z-Score']['KPI'])" :key="i">{{ v }}</md-icon>
                          </div>
                        </div>
                        <LineChart v-if="modifiedZScoreChartData" :ycolor="'#000'" :xcolor="'#000'" :height="'200px'" :categories="modifiedZScoreChartData.labels" :chartdata="modifiedZScoreChartData.series"/>
                        <div class="chart-footer mt-2">
                          <p>
                            A modified form of the Altman Z-Score which evaluates default risk. The modified Z-Score substitutes Discretionary Owner Earnings for Net Profit and Net Worth for Retained Earnings to better capture small business operations. In all cases higher (at or above the industry level) is desired. Modified Z-Score calculations for this industry are: ([Operating Income/Total Assets]*6.72) + ([Net Worth/Total Liabilities]*1.05) + ([Working Capital/Total Assets]*6.5) + ([Discretionary Owner Earnings/Total Assets]*3.26) </p>
                        </div>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50 mb-2">
                        <div class="chart-header">
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Interest Coverage ({{ this.vestimateReport.IF.timeSeries }})</div>
                          </h4>
                          <div v-if="this.vestimateReport.IF.scores['Interest Coverage']['KPI'] && this.vestimateReport.IF.scores['Interest Coverage']['KPI'] === 'n/a'" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                          </div>
                          <div v-else-if="this.vestimateReport.IF.scores['Interest Coverage']['KPI']" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Current Ratio']['KPI'])" :key="i">{{ v }}</md-icon>
                          </div>
                        </div>
                        <LineChart v-if="interestCoverageChartData" :ycolor="'#000'" :xcolor="'#000'" :height="'200px'" :categories="interestCoverageChartData.labels" :chartdata="interestCoverageChartData.series"/>
                        <div class="chart-footer mt-2">
                          <p>
                            [Earnings before Interest, Income Taxes due, Depreciation-Amortization]/Interest expense. Assesses financial stability by examining whether a company is profitable enough to pay interest expense. A ratio >1.00 is desirable. </p>
                        </div>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50 mb-2">
                        <div class="chart-header">
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Total Liabilities: Net Worth ({{ this.vestimateReport.IF.timeSeries }})</div>
                          </h4>
                          <div v-if="this.vestimateReport.IF.scores['Total Liabilities to Net Worth']['KPI'] && this.vestimateReport.IF.scores['Total Liabilities to Net Worth']['KPI'] === 'n/a'" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                          </div>
                          <div v-else-if="this.vestimateReport.IF.scores['Total Liabilities to Net Worth']['KPI']" class="md-button-content">
                            <md-icon v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Total Liabilities to Net Worth']['KPI'])" :key="i">{{ v }}</md-icon>
                          </div>
                        </div>
                        <LineChart v-if="totalLiabilitiesChartData" :ycolor="'#000'" :xcolor="'#000'" :height="'200px'" :categories="totalLiabilitiesChartData.labels" :chartdata="totalLiabilitiesChartData.series"/>
                        <div class="chart-footer mt-2">
                          <p>
                            Total liabilities/Net Worth. This ratio helps to clarify the total risk impact of debt. Total liability levels should be comfortably less than Net Worth except in special circumstances. The most advantageous ratios are around or somewhat below industry norms, balancing current and long term liability values. </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page19" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="about_info page">
              <div class="section_body">
                <div class="section_title">
                  <h2>VESTIMATE-PRO METHODOLOGY</h2>
                </div>
                <div class="data_box_about">
                  <p>Vestimate-Pro business values are based on transactional multiples, industry financial and market trend analysis applied to our proprietary calculation protocols.
                    <br/><br/> Bizminer develops and publishes financial statement averages for about five thousand US industry classifications. Industry and sales class-specific data from Bizminer's industry financial analysis content is integrated into final Vestimate-Pro calculations. That content has been accepted in US Tax Court and is utilized by thousands of accounting, valuation, banking and business assistance professionals; by almost one hundred university libraries and by taxing agencies in multiple countries.
                    <br/><br/> This core Bizminer content is integrated with Price/Earnings and Price/Sales multiples derived from almost 30,000 business transactions collected by DealStats. Bizminer conducts intensive cleaning for outliers in the DealStats transaction database at the NAICS-6 level after segregating the data by industry and size, scouring for outliers and creating four sized tiers ($2.5m; $2.5m-$25m; $25m-plus and industry-wide) to develop multipliers used with our own enterprise sales and average industry performance content. Price/Earnings and Price/Revenue multiples are derived for five intervals: [Low]-[Quartile 1]-[Median]-[Quartile 2]-[High]. A series of core KPIs representing all five critical KPI categories (Cash Flow/Liquidity; Profitability; Efficiency; Debt-Risk; Market Opportunity) are then scored and applied using Bizminer’s proprietary algorithms to calculate a final business values or value range.
                    <br/><br/> KPI variances for all selected years are applied to determine the KPI score. With two exceptions, all scored KPIs used for this value report are calculated using our Standard Scoring methodology, that is, higher is generally better:
                    <br/><br/>
                  <ul>
                    <li>+/-10% from average= 3</li>
                    <li>+11% to +20% above average= 4</li>
                    <li>>20% above average= 5</li>
                    <li>+11% to +20% below average= 2</li>
                    <li>>20% below average= 1</li>
                  </ul>
                  <br/> Days Payable uses a Balanced Scoring framework, that is, closer to the industry standard is best, so that no variance from industry values would receive 5 stars. Days Receivable uses Reverse Scoring, where lower than the industry standard is better; 20% below the industry standard, for example, would receive 5 stars.
                  <br/><br/> Displayed scoring is based on a scale of 1-5, with 5 being "best" and 1 being "worst". All percentages are shown as a variance from the industry peer group average.
                  <br/><br/> Variances are also applied with more finely calibrated and weighted differentials to the final Vestimate-Pro business value calculations; weight values are assigned for each percentage point of variance for each KPI.</p>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page20" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="about_info page">
              <div class="section_body">
                <div class="section_title">
                  <h2>METHODOLOGY(continued)</h2>
                </div>
                <div class="data_box_about">
                  <p>Final business values also incorporate one time income-expense addbacks noted by the report developer, which may not be visible in formal financial statements.
                    <br/><br/> By default, the report applies 100% of the value calculations to the most recent year of inputs (including sales and market growth values if that data is available). If the developer chooses to integrate KPIs and other metrics into the final value calculation, values are weighted in the final calculations like this:
                    <br/><br/> 3-year Option: 2016: 20%; 2017: 20%; 2018: 60%
                    <br/> 2-year Option: 2017: 33.3%; 2018: 67.7% <br/> 1-year Option: 2018: 100% <br/><br/>
                  </p>
                  <h5 class="table_header mt-0">Market Analysis Values</h5>
                  <p>
                    The analysis integrates industry market volume trends, an industry site sales growth yardstick and a market penetration index developed at national and local levels in Bizminer’s Industry Market Trend report series. That content integrates the industry and custom market area selection with firm performance and scores the results.
                    <br/><br/> Sales-related calculations are developed with firm‐level data which is integrated with BizMiner’s internally generated Sales per Employee projections. SPE data is both industry‐ and location‐specific; values are updated monthly by the application of US Census data and five industry and consumer price and productivity indices from the Bureau of Labor Statistics and other federal agencies.
                    <br/><br/> The Sales per Household metric integrates Census data with Bizminer’s industry market sales calculations to produce Sales per Household values applied to the Market Opportunity Index. Although it is displayed in tables, the Market Opportunity Index is not applied to scoring or business value calculations where the selected market is US (due to lack of a market comparison), or where the industry is overwhelmingly B-to-B, including these parent NAICS and their offspring: 11; 21; 31-32-33 (except 3118; 311991; 323111; 323113); 33; 42; 481; 482; 483111; 483211; 486; 493; 512; 533; 55; 5611; 5612.
                    <br/><br/> Cessation rates track the experience of business establishments, firms, small businesses, branches and startups doing business at the start of the time series, and still in operation today. Firms which relocate but maintain independent operations are considered survivors if they do not move out of the jurisdiction being analyzed. Firms which become subsidiary locations, or whose location is terminated, are grouped with others which ceased operation. Any business entity which does not evidence ongoing operations (for example, by registering with government agencies, credit reporting services or business directories) is considered to have ceased viable operations and is classified in the "ceased operation" category.
                  </p>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page21" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="about_info page">
              <div class="section_body">
                <div class="section_title">
                  <h2>KPI SCORING</h2>
                </div>
                <div class="data_box_about">
                  <p>In most cases, the variance for each metric measures the percentage difference between input firm ratios and the industry average. The Sales per Household Market Opportunity Index and Location Quotient compare local and national market data to determine the variance between the two.
                    <br/><br/> Each variance results in a Score of 1-5 (5 being best) for each year of each selected ratio. The application of the Variances to the Score depends on the specific metric; in most cases higher is better (Standard Scoring); in some, lower (Reverse Scoring) is better; in a few, closest to the industry average (Balanced Scoring) is best.
                    <br/><br/>
                  </p>
                  <div class="md-layout">
                    <div class="md-layout-item md-medium-size-100 md-size-50 mb-2">
                      <p>
                        <strong>Approach to Scored KPIs:</strong>
                      <ul>
                        <li> Owner Earnings (%)-Standard</li>
                        <li>Annual Sales Growth Sales-Standard</li>
                        <li>Industry Market Volume-Standard</li>
                        <li>Sales per Household Market Opportunity Index-Standard</li>
                        <li> Efficiency Index-Standard</li>
                        <li> Days Receivable-Reverse</li>
                        <li>Current Ratio-Standard</li>
                        <li>Current Liabilities:Net Worth-Reverse</li>
                        <li>Total Liabilities:Net Worth-Reverse</li>
                        <li>Modified Z‐Score-Standard</li>
                        <li>Interest Coverage: Standard</li>
                      </ul>
                      <br/><br/></p>
                    </div>
                    <div class="md-layout-item md-medium-size-100 md-size-50 mb-2">
                      <p>
                        <strong>Scoring Calculations:</strong>
                      <ul>
                        <li> Standard (basically higher is better)</li>
                        <li> +/-10% from average= 3</li>
                        <li>+11% to +20% above average= 4</li>
                        <li>>20% above average= 5</li>
                        <li> >20% below average= 1</li>
                        <li> Reverse (lower is better)</li>
                        <li>+/-10% from average= 3</li>
                        <li>+11% to +20% above average= 2</li>
                        <li>>20% above average= 1</li>
                        <li>+11% to +20% below average= 4</li>
                        <li>>20% below average= 5</li>
                      </ul>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page22" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="about_info page">
              <div class="section_body">
                <div class="section_title">
                  <h2>DATA SOURCES</h2>
                </div>
                <div class="data_box_about">
                  <p>BizMiner data is widely accepted for industry analytical work, benchmarking, valuations, forensics and litigation. BizMiner content is accepted in US Tax Court (Bauer vs. IRS: T.C. Memo. 2012-156) and is utilized by state, provincial and national taxing agencies in the US and Canada.
                    <br/><br/> Raw data analyzed for BizMiner reports is sourced from an array of the nation's government and private statistical sources. None of these raw data sources creates the final measures reflected in BizMiner industry profiles. In total, BizMiner accesses over a billion sourced data points from 15 million business operations for each of its twice annual updates covering a 3-5 year time series. Historical data and BizMiner algorithms are used to inform and test projections for non-reporting firms. Data elements are sourced specifically from:
                    <br/><br/>
                  <ul>
                    <li>IRS SOI Corporation Tax Book</li>
                    <li>IRS Statistics of Income</li>
                    <li>US Economic Census</li>
                    <li>US Census Quarterly Financial Reports</li>
                    <li>US Census County Business Patterns</li>
                    <li>Bureau of Labor Statistics Monthly Employment Reports</li>
                    <li>Bureau of Labor Statistics Monthly Unemployment Reports</li>
                    <li>Bureau of Labor Statistics Annual Wage Survey</li>
                    <li>Bureau of Labor Statistics Industry Productivity Reports</li>
                    <li>Bureau of Labor Statistics Price Indices</li>
                    <li>National Agricultural Statistical Service</li>
                    <li>US Census Quarterly Financial Reports</li>
                    <li>US Census Retail Trade Report</li>
                    <li>InfoGroup, Inc</li>
                    <li>DealStats</li>
                    <li>Credit Reporting Agencies</li>
                    <li>American Community Survey</li>
                  </ul>
                  <br/> While 100% firm coverage is desirable for analysis purposes, the greatest value of BizMiner reports rests in discerning patterns of activity, which are reflected in the large samples used to develop our reports. The overall current coverage of the databases surpasses 13 million active business operations at any point in time.
                  <br/> Contact Bizminer at: 2601 Market Street, Camp Hill PA 17011:wwwww.bizminer.com</p>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
          <section ref="page23" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="about_info page">
              <div class="section_body">
                <div class="section_title">
                  <h2>VESTIMATE USE: TERMS AND CONDITIONS</h2>
                </div>
                <div class="data_box_about">
                  <p>This report is authorized for in-house use by the purchaser and other individuals licensed or authorized by Bizminer. No other persons in the licensing organization or its contractors may access, analyze, utilize or review Licensed Content. Licensees are permitted to utilize the content with bona fide third-party end-user clients as part of significantly value-added reports or projects. For example, content may be included as part of a custom business plan, broker communications with prospective buyers, custom valuation report individually developed and integrated by professional licensees for bona fide end user clients, or as part of a personalized financial review with counseling conducted by an accountant or consultant. The number of clients or client entities to which permitted uses apply is not limited.
                    <br/><br/> Limitations on Use: If you use Licensed Content in a manner that exceeds any of the limitations below, you are in breach of these Terms. If your needs exceed these limitations, you may qualify for a separate Extended Electronic License with Bizminer. Any such use without a separately negotiated Extended Commercial Subscription constitutes a breach of this License Agreement.
                    <br/><br/> Access to Licensed Content is subject to the following restrictions:
                    <br/><br/> The creation of files or databases which aggregate Licensed Content for in-house use is limited to part or all of 25 Licensed Content reports.
                    <br/><br/> Content can NOT be harvested for integration into either Subscriber or third-party end user databases. "Harvested" content includes data which is loaded without a current due diligence need or immediate, active client engagement.
                    <br/><br/> Use or integration of Licensed Content in any electronic database or engine for either front end or back-end use with third party clients, or for any online use or integration, displayed or otherwise, is strictly prohibited unless such use or display is confined to authorized Users.
                    <br/><br/> Distribution of any Licensed Content beyond bona fide third party end-user clients as described above is prohibited, including distribution at educational, marketing or other quasi-public or by-invitation public events; any electronic or other posting on a web site or in any other electronic format aside from bona fide end user clients as detailed above; distribution of Licensed Content reports or data in whole or part without the addition of significant value-added materials or delivery of significant value-added services in addition to the licensed report or content. Otherwise, data resale or re-engineering, web or electronic-based commerce or distribution or re-sale to anyone outside your organization is not permitted.
                    <br/><br/> As is the case with any databases this large, some errors are inevitable. Some firms are missed and specific information on others is lacking from the database. Not all information received is uniform or complete, resulting in the need to develop projection algorithms for specific industry segments and metrics in some report series. No representation is made as to the accuracy of the databases utilized or the results of subsequent analyses. Neither the Bizminer nor its resellers have undertaken independent primary research to confirm the accuracy of the data utilized in the Profile analyses. Neither the Bizminer nor its resellers are responsible for conclusions drawn or decisions made based upon this data or analysis. In no event will Bizminer or its resellers be liable for any damages, direct, indirect, incidental or consequential resulting from the use of the information contained in Bizminer reports.
                  </p>
                </div>
              </div>
              <p class="common_footer">Copyright © 2022 Bizminer. All Rights Reserved.</p>
            </div>
          </section>
        </div>
      </section>
    </VueHtml2pdf>
  </div>
</template>
<script>
import ratingMixin from '@/mixins/rating-mixin';
import {ProfileCard} from '@/components';
import LineChart from '@/components/LineChart.vue';
import VueHtml2pdf from 'vue-html2pdf';
import {mapState} from 'vuex';
import moment from 'moment'

export default {
  components: {
    VueHtml2pdf,
    ProfileCard,
    LineChart,
  },
  mixins: [ratingMixin],
  props: ['headerData', 'user'],
  data() {
    return {
      average: 0,
      kpiAverageTotal: 0,
      test: null,
      valuationLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 80,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
        },
      },
      moment: moment,
      historiacalLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 80,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
        },
      },
      sales_value: '',
      sales_growth: '',
      earning_value: '',
      earning_growth: '',
      historical_earnings: [],
      historical_income: [],
      chartYears: [],
      VRIndustryMarketBenchmarks: [],
      basicInfo: [
        {
          name: "Industry Market Benchmarks"
        },
        {
          name: "FTE Employees",
        },
        {
          name: "Sales per Employee",
        },
        {
          name: "FTE Average Wage",
        },
        {
          name: "Industry Peer Group Firms Analyzed",
        },
        {
          name: "Industry Market Average Site Sales",
        },
        {
          name: "Industry Market Gross Volume",
        },
        {
          name: "Market Sales/Household",
        },
        {
          name: "US Sales/Household",
        },
      ],
      showDialog: false,
      SummaryFinancialRatios: [],
      currentRatioLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200
            }
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "230px",
        },
      },
      daysPayableLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200
            }
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 20,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "300px",
          fullWidth: true,
        },
      },
      ownerEarningsPercentageLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200
            }
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "260px",
          fullWidth: true,
        },
      },
      ownerEarningsGrowthLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200
            }
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "220px",
          fullWidth: true,
        },
      },
      salesGrowthLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '220px',
          fullWidth: true,
        },
      },
      returnAssetsLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '270px',
          fullWidth: true,
        },
      },
      daysRecievableLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '250px',
          fullWidth: true,
        },
      },
      efficiencyIndexLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
          fullWidth: true,
        },
      },
      modifiedZScoreLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '220px',
          fullWidth: true,
        },
      },
      interestCoverageLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "270px",
          fullWidth: true,
        },
      },
      totalLiabilitiesLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '240px',
          fullWidth: true,
        },
      },
      valuationDriversChartData: null,
      historicalValueChartData: null,
      currentRatioChartData: null,
      daysPayableChartData: null,
      totalLiabilitiesChartData: null,
      ownerEarningsChartData: null,
      ownerEarningsGrowthChartData: null,
      annualSalesGrowthChartData: null,
      returnOnAssetsChartData: null,
      daysReceivablesChartData: null,
      efficiencyIndexChartData: null,
      interestCoverageChartData: null,
      modifiedZScoreChartData: null,
      VarianceFinancialAnalysis: [],
      DollarsFinancialAnalysis: [],
      PercentagesFinancialAnalysis: [],
      VarianceFinancialAnalysisAux: [],
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    headerInfo() {
    },
    vestimateReport(newVal, oldVal) {
      this.init();
    },
  },
  computed: {
    ...mapState({
      client: (state) => state?.user?.vestimate_report?.data?.developerClient,
      vestimateReport: (state) => state?.user?.vestimate_report?.data,
      score: (state) => {
        if (state?.user?.vestimate_report?.data && state?.user?.vestimate_report?.data?.IF) {
          return state?.user?.vestimate_report?.data?.IF['scores'];
        }
        return '';
      },
      naics: (state) => state?.user?.vestimate_report?.data?.IMRnaics,
      industryRollup: state => state.user.vestimate_report.data.industry_rollup,
      industryName: (state) => state?.user?.vestimate_report?.data?.IMRindustry,
      displayArea: (state) => state?.user?.vestimate_report?.data?.MR?.area,
      reportDate: (state) => state?.user?.vestimate_report?.data?.report_date,
      recentYear: (state) => state?.user?.vestimate_report?.data?.recentYear,
      companyName: (state) =>
          state?.user?.vestimate_report?.data?.input_structure ? state?.user?.vestimate_report?.data?.input_structure['Company Name'][
              'value'
              ] : '',
      all_us: (state) => state?.user?.vestimate_report?.data?.all_us,
      opp_index_exclude: (state) => state?.user?.vestimate_report?.data?.opp_index_exclude,
    }),
    pdfDownloadSetting() {
      return this.user && this.user.preferences && this.user.preferences.defaultPDFDownload ? this.user.preferences.defaultPDFDownload : '_blank'
    },
    // user(){
    //     return this.$store.state.user.user;
    // },
    leftRatioOutput() {
      return this.vestimateReport.ratioOutput.map((ratio) => ratio.left);
    },
    rightRatioOutput() {
      return this.vestimateReport.ratioOutput.map((ratio) => ratio.right);
    },
  },
  methods: {
    generateReport2() {
      this.$refs.html2Pdf.generatePdf()
    },
    onProgress($e) {
    },
    async beforeDownload({html2pdf, options, pdfContent}) {
      this.pdfLoading = true;
      this.$store.commit('user/SET_PDF_LOADING', true);
      let page1 = this.$refs.page1;
      let page2 = this.$refs.page2;
      let page3 = this.$refs.page3;
      let page4 = this.$refs.page4;
      let page5 = this.$refs.page5;
      let pageIntro = this.$refs.pageIntro;
      let pageIntro2 = this.$refs.pageIntro2;
      let page6 = this.$refs.page6;
      let page7 = this.$refs.page7;
      let companyContext = this.$refs.companyContext;
      let companyContext_prod = this.$refs.companyContext_prod;
      let page8 = this.$refs.page8;
      let page9 = this.$refs.page9;
      let page10 = this.$refs.page10;
      let page11 = this.$refs.page11;
      let page12 = this.$refs.page12;
      let page13 = this.$refs.page13;
      let industryAnalysis = this.$refs.industryAnalysis;
      let industryAnalysisDollars = this.$refs.industryAnalysisDollars;
      let industryAnalysisVariance = this.$refs.industryAnalysisVariance;
      let page14 = this.$refs.page14;
      let page15 = this.$refs.page15;
      let page16 = this.$refs.page16;
      let page17 = this.$refs.page17;
      let page18 = this.$refs.page18;
      let page19 = this.$refs.page19;
      let page20 = this.$refs.page20;
      let page21 = this.$refs.page21;
      let page22 = this.$refs.page22;
      let page23 = this.$refs.page23;
      let pages = [
        page1,
        page2,
        pageIntro,
        pageIntro2,
        page3,
        page4,
        page5,
        page6,
        page7
      ]
      if (companyContext) {
        pages.push(companyContext);
      }
      if(companyContext_prod) {
        pages.push(companyContext_prod);
      }
      pages.push(page8);
      pages.push(page9);
      pages.push(page10);
      pages.push(page11);
      pages.push(page12);
      pages.push(page13);
      pages.push(industryAnalysis);
      pages.push(industryAnalysisDollars);
      pages.push(industryAnalysisVariance);
      pages.push(page14);
      pages.push(page15);
      pages.push(page16);
      pages.push(page17);
      pages.push(page18);
      pages.push(page19);
      pages.push(page20);
      pages.push(page21);
      pages.push(page22);
      pages.push(page23);
      options.pagebreak = {avoid: 'ul', mode: 'css', after: '.br-after'};
      var worker = html2pdf().set(options).from(pages[0]).toPdf();
      pages.slice(1).forEach(function (page) {
        worker = worker.get('pdf').then(function (pdf) {
          pdf.addPage();
        }).from(page).toContainer().toCanvas().toPdf();
      });
      worker.get("pdf").then(pdf => {
        if (this.$store.getters["user/pdfMustBeDownloaded"]) worker.save();
        else window.open(pdf.output("bloburl"), "_blank");
      });
    },
    async afterDownload() {
      this.pdfLoading = false;
      this.$store.commit('user/SET_PDF_LOADING', false);
    },
    init() {
      if (!this.vestimateReport || (this.vestimateReport && !Object.keys(this.vestimateReport).length)) {
        return;
      }
      this.checked = Object.keys(this.vestimateReport.displaySettings).filter((i) => i);
      let me = this;
      if (!this.vestimateReport || !this.vestimateReport.IF) {
        return;
      }
      this.sales_value = me.numberWithPoints(this.sales_value);
      let lastYearIndex = this.vestimateReport.last_year_index;
      let sales_growth_year = this.vestimateReport.IF.ifDataYears[lastYearIndex];
      this.sales_growth = this.vestimateReport.IF.data[sales_growth_year][
          'Market Sales Growth'
          ]['firm_percentage'];
      let lastYearInput = this.vestimateReport.last_year_of_inputs;
      this.earning_value = this.vestimateReport.IF.data[lastYearInput][
          'Owner Earnings'
          ]['firm_percentage'];
      this.earning_growth = this.vestimateReport.IF.data[sales_growth_year][
          'Owner Earnings'
          ]['percentage'];
      this.vestimateReport.IF.ifDataYears.forEach((el, index) => {
        let earnings = {};
        let income = {};
        earnings.year = el;
        income.year = el;
        if (el !== this.vestimateReport.lastYearValue) {
          earnings.value = this.vestimateReport.vestimate.data[el]['earnings'][
              'sales_value'
              ];
          income.value = this.vestimateReport.vestimate.data[el]['sales'][
              'sales_value'
              ];
        } else {
          earnings.value = this.vestimateReport.vestimate.earnings;
          income.value = this.vestimateReport.vestimate.income;
        }
        this.historical_earnings.push(earnings);
        this.historical_income.push(income);
      });
      let valuation_chart = this.vestimateReport.charts.valuation_drivers_chart
          .data;
      let valuation_years = [];
      let valuation_data = [];
      valuation_chart.forEach((element, index) => {
        valuation_years.push(element.date);
      });
      valuation_years = valuation_years.filter(function (item, pos) {
        return valuation_years.indexOf(item) == pos;
      });
      valuation_chart.forEach((element, index) => {
        let n = {};
        n.name = element.category;
        n.dates = element.value;
        valuation_data.push(n);
      });
      let valueArr = valuation_data.map(function (item) {
        return item.name;
      });
      let valuation_series = [];
      valueArr.some(function (item, idx) {
        if (valueArr.indexOf(item) != idx) {
          let f = {};
          let y = [];
          f.name = item;
          valuation_data.forEach((element, index) => {
            if (element.name == item) {
              y.push(element.dates);
              f.dates = y;
            }
          });
          valuation_series.push(f);
        }
      });
      valuation_years = valuation_years.map((item) => item.split('-')[0]);
      valuation_series.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithPoints(e);
        });
        return item;
      });
      // this.valuationLineChart.data = {
      // labels: valuation_years,
      // series: valuation_series.map((item) => ({
      //     name: item.name,
      //     data: item.dates,
      // })),
      // };
      this.valuationDriversChartData = {
        labels: valuation_years,
        series: valuation_series.map((item) => ({
          name: item.name,
          data: item.dates,
        })),
      };
      let historical_chart = this.vestimateReport.charts
          .historical_vestimate_chart.data;
      let historical_years = [];
      let historical_data = [];
      historical_chart.forEach((element, index) => {
        historical_years.push(element.date);
      });
      historical_years = historical_years.filter(function (item, pos) {
        return historical_years.indexOf(item) == pos;
      });
      historical_chart.forEach((element, index) => {
        let n = {};
        n.name = element.category;
        n.dates = element.value;
        historical_data.push(n);
      });
      var historicalArr = historical_data.map(function (item) {
        return item.name;
      });
      let historical_series = [];
      historicalArr.some(function (item, idx) {
        if (historicalArr.indexOf(item) != idx) {
          let f = {};
          let y = [];
          f.name = item;
          historical_data.forEach((element, index) => {
            if (element.name == item) {
              y.push(element.dates);
              f.dates = y;
            }
          });
          historical_series.push(f);
        }
      });
      historical_years = historical_years.map((item) => item.split('-')[0]);
      historical_series.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithPoints(e);
        });
        return item;
      });
      // this.historiacalLineChart.data = {
      // labels: historical_years,
      // series: historical_series.map((item) => ({
      //     name: item.name,
      //     data: item.dates,
      // })),
      // };
      this.historicalValueChartData = {
        labels: historical_years,
        series: historical_series.map((item) => ({
          name: item.name,
          data: item.dates,
        })),
      };
      let section = this.$route.query.section;
      if (!section) {
        section = "dollar";
      }
      this.switchView(section);
      let fullYears = this.vestimateReport.IF['ifDataYearsFull'];
      fullYears = fullYears.map(Number);
      let f = {};
      f.benchmark = "";
      f.industry = {};
      f.firm = {};
      this.basicInfo.forEach((element, index) => {
        let c = {};
        c.industry = {};
        c.firm = {};
        c['benchmark'] = element.name;
        fullYears.forEach((el) => {
          c.industry[el] = this.vestimateReport.IF.data[el][element.name] ? this.vestimateReport.IF.data[el][element.name].dollar : "";
          c.firm[el] = this.vestimateReport.IF.data[el][element.name] ? this.vestimateReport.IF.data[el][element.name].firm_dollar : "";
          f.industry[el] = el;
          f.firm[el] = el;
        })
        this.VRIndustryMarketBenchmarks.push(c);
      })
      this.VRIndustryMarketBenchmarks.unshift(f);
      /************************** Kpi Details*************************************/
      /************************** Kpi Details*************************************/
      let fullYears2 = this.vestimateReport.IF['ifDataYearsFull'];
      fullYears2 = fullYears2.map(Number);
      let summaryNames = [
        {
          name: "Cash Flow",
        },
        {
          name: 'Current Ratio',
        },
        {
          name: 'Days Payable',
        },
        {
          name: 'Profitability',
        },
        {
          name: 'Discretionary Owner Earnings',
        },
        {
          name: 'Growth',
        },
        {
          name: 'DOE Growth',
        },
        {
          name: 'Average Annual Sales Growth',
        },
        {
          name: 'Efficiency',
        },
        {
          name: 'Days Receivable',
        },
        {
          name: 'Efficiency Index',
        },
        {
          name: 'Debt-Risk',
        },
        {
          name: 'Modified Z-Score',
        },
        {
          name: 'Interest Coverage',
        },
        {
          name: 'Total Liabilities to Net Worth',
        },
      ];
      /**
       * Checking and adding to summary
       */
      if (!this.opp_index_exclude) {
        summaryNames.push({
          name: 'Market Opportunity'
        });
        summaryNames.push({
          name: "Industry market Growth (" + this.vestimateReport.IF['timeSeriesShort'] + ")"
        });
      }
      summaryNames.push({
        name: 'Market Opportunity Index'
      })
      let ff = {};
      ff.name = "";
      ff.industry = {};
      ff.firm = {};
      ff.variance = {};
      summaryNames.forEach((element, index) => {
        let kk = {};
        kk.id = index;
        kk.industry = {};
        kk.firm = {};
        kk.variance = {};
        kk['name'] = element.name;
        fullYears2.forEach((el) => {
          if (this.vestimateReport.IF.data[el][element.name]) {
            if (this.vestimateReport.IF.data[el][element.name].dollar) {
              kk.industry[el] = this.vestimateReport.IF.data[el][element.name].dollar;
            } else {
              kk.industry[el] = "n/a";
            }
            if (this.vestimateReport.IF.data[el][element.name].firm_dollar) {
              kk.firm[el] = this.vestimateReport.IF.data[el][element.name].firm_dollar;
            } else {
              kk.firm[el] = "n/a";
            }
            if (this.vestimateReport.IF.data[el][element.name].variance) {
              kk.variance[el] = this.vestimateReport.IF.data[el][element.name].variance;
            } else {
              kk.variance[el] = "n/a";
            }
          } else {
            kk.industry[el] = this.customElement(element.name, el, this.vestimateReport.IF.data[el], 'industry');
            kk.firm[el] = this.customElement(element.name, el, this.vestimateReport.IF.data[el], 'firm');
            kk.variance[el] = this.customElement(element.name, el, this.vestimateReport.IF.data[el], 'variance');
          }
          ff.industry[el] = el;
          ff.firm[el] = el;
          ff.variance[el] = el;
        })
        this.SummaryFinancialRatios.push(kk);
      })
      let current_ratio_chart = this.vestimateReport.charts.current_ratio_chart.data;
      let current_ratio_years = [];
      let current_ratio_data = [];
      current_ratio_chart.forEach((element, index) => {
        current_ratio_years.push(element.date)
      })
      current_ratio_years = current_ratio_years.filter(function (item, pos) {
        return current_ratio_years.indexOf(item) == pos;
      });
      current_ratio_years = current_ratio_years.map((item) => item.split('-')[0]);
      current_ratio_chart.forEach((element, index) => {
        current_ratio_data.push(element.value)
      })
      let current_ratio_series = [];
      current_ratio_data.forEach((element, index) => {
        if (element.includes('.')) {
          element = parseFloat(element);
          current_ratio_series.push(element);
        }
      });
      // this.currentRatioLineChart.data = {
      // labels: current_ratio_years,
      // series: [current_ratio_series],
      // };
      if (current_ratio_series.length > 3) {
        current_ratio_series.forEach((ratio_series) => {
          if (current_ratio_years.length < current_ratio_series.length) {
            let lastYear = current_ratio_years[current_ratio_years.length - 1];
            current_ratio_years.push(parseInt(lastYear) + 1);
          }
        });
      }
      this.currentRatioChartData = {
        labels: current_ratio_years,
        series: [{
          name: 'Current Ratio',
          data: current_ratio_series,
        }],
      };
      let days_payable_chart = this.vestimateReport.charts.days_payable_chart
          .data;
      let days_payable_years = [];
      let days_payable_data = [];
      days_payable_chart.forEach((element, index) => {
        days_payable_years.push(element.date)
      })
      days_payable_years = days_payable_years.filter(function (item, pos) {
        return days_payable_years.indexOf(item) == pos;
      })
      days_payable_years = days_payable_years.map(item => item.split("-")[0]);
      days_payable_chart.forEach((element, index) => {
        days_payable_data.push(element.value)
      })
      let days_payable_series = [];
      days_payable_data.forEach((element, index) => {
        if (element.includes('.')) {
          element = parseFloat(element);
          days_payable_series.push(element);
        }
      });
      // this.daysPayableLineChart.data = {
      // labels: days_payable_years,
      // series: [days_payable_series],
      // };
      if (days_payable_series.length > 3) {
        days_payable_series.forEach((ratio_series) => {
          if (days_payable_years.length < days_payable_series.length) {
            let lastYear = days_payable_years[days_payable_years.length - 1];
            days_payable_years.push(parseInt(lastYear) + 1);
          }
        });
      }
      this.daysPayableChartData = {
        labels: days_payable_years,
        series: [{
          name: 'Days Payable',
          data: days_payable_series,
        }],
      };
      let owner_earnings_percentage_chart = this.vestimateReport.charts
          .owner_earnings_percentage_chart.data;
      let owner_earnings_percentage_years = [];
      let owner_earnings_percentage_data = [];
      owner_earnings_percentage_chart.forEach((element, index) => {
        owner_earnings_percentage_years.push(element.date)
      })
      owner_earnings_percentage_years = owner_earnings_percentage_years.filter(function (item, pos) {
        return owner_earnings_percentage_years.indexOf(item) == pos;
      })
      owner_earnings_percentage_years = owner_earnings_percentage_years.map(item => item.split("-")[0]);
      owner_earnings_percentage_chart.forEach((element, index) => {
        let n = {};
        n.name = element.category;
        n.dates = element.value;
        owner_earnings_percentage_data.push(n)
      })
      let valueArr2 = owner_earnings_percentage_data.map(function (item) {
        return item.name
      });
      let owner_earnings_percentage_series = [];
      let uniqueArray = [];
      valueArr2.forEach(function (item, idx) {
        if (uniqueArray.indexOf(item) === -1) {
          uniqueArray.push(item)
        }
      });
      uniqueArray.forEach((item, index) => {
        let ff = {};
        let y = [];
        ff.name = item;
        owner_earnings_percentage_data.forEach((element, index) => {
          if (element.name == item) {
            y.push(element.dates);
            ff.dates = y;
          }
        });
        owner_earnings_percentage_series.push(ff);
      })
      owner_earnings_percentage_series.map(item => {
        item.dates = item.dates.map(e => {
          if (e.includes('%')) {
            return e.replace('%', ' ')
          }
        })
        return item
      })
      // this.ownerEarningsPercentageLineChart.data = {
      //     labels: owner_earnings_percentage_years,
      //     series: owner_earnings_percentage_series.map((item) => ({
      //         name: item.name,
      //         data: item.dates,
      //     })),
      // };
      this.ownerEarningsChartData = {
        labels: owner_earnings_percentage_years,
        series: owner_earnings_percentage_series.map((item) => ({
          name: item.name,
          data: item.dates,
        })),
      };
      let owner_earnings_growth_chart = this.vestimateReport.charts
          .owner_earnings_growth_chart.data;
      let owner_earnings_growth_years = [];
      let owner_earnings_growth_data = [];
      owner_earnings_growth_chart.forEach((element, index) => {
        owner_earnings_growth_years.push(element.date)
      })
      owner_earnings_growth_years = owner_earnings_growth_years.filter(function (item, pos) {
        return owner_earnings_growth_years.indexOf(item) == pos;
      })
      owner_earnings_growth_years = owner_earnings_growth_years.map(item => item.split("-")[0]);
      owner_earnings_growth_chart.forEach((element, index) => {
        let n = {};
        n.name = element.category;
        n.dates = element.value;
        owner_earnings_growth_data.push(n)
      });
      let valueArr3 = owner_earnings_growth_data.map(function (item) {
        return item.name
      });
      let owner_earnings_growth_series = [];
      let uniqueArray3 = [];
      valueArr3.forEach(function (item, idx) {
        if (uniqueArray3.indexOf(item) === -1) {
          uniqueArray3.push(item)
        }
      });
      uniqueArray3.forEach((item, index) => {
        let ff = {};
        let y = [];
        ff.name = item;
        owner_earnings_growth_data.forEach((element, index) => {
          if (element.name == item) {
            y.push(element.dates);
            ff.dates = y;
          }
        });
        owner_earnings_growth_series.push(ff);
      })
      owner_earnings_growth_series.map(item => {
        item.dates = item.dates.map(e => {
          if (e.includes('%')) {
            return e.replace('%', ' ')
          } else {
            return e;
          }
        })
        return item
      })
      /*   owner_earnings_growth_data.forEach((element, index) => {
            if (element.includes('.')) {
                element = parseFloat(element);
                owner_earnings_growth_series.push(element);
            }
            });*/
      this.ownerEarningsGrowthChartData = {
        labels: owner_earnings_percentage_years,
        series: owner_earnings_growth_series.map((item) => ({
          name: item.name,
          data: item.dates,
        })),
      };
      let sales_growth_chart = this.vestimateReport.charts.sales_growth_chart
          .data;
      let sales_growth_years = [];
      let sales_growth_data = [];
      sales_growth_chart.forEach((element, index) => {
        sales_growth_years.push(element.date)
      })
      sales_growth_years = sales_growth_years.filter(function (item, pos) {
        return sales_growth_years.indexOf(item) == pos;
      })
      sales_growth_years = sales_growth_years.map(item => item.split("-")[0]);
      let sales_growth_series = [];
      let uniqueArray4 = [];
      sales_growth_chart.forEach((element, index) => {
        let n = {};
        n.name = element.category;
        n.dates = element.value;
        sales_growth_data.push(n)
      });
      let valueArr4 = sales_growth_data.map(function (item) {
        return item.name
      });
      valueArr4.forEach(function (item, idx) {
        if (uniqueArray4.indexOf(item) === -1) {
          uniqueArray4.push(item)
        }
      });
      uniqueArray4.forEach((item, index) => {
        let ff = {};
        let y = [];
        ff.name = item;
        sales_growth_data.forEach((element, index) => {
          if (element.name == item) {
            y.push(element.dates);
            ff.dates = y;
          }
        });
        sales_growth_series.push(ff);
      })
      sales_growth_series.map(item => {
        item.dates = item.dates.map(e => {
          if (e.includes('%')) {
            return e.replace('%', ' ')
          }
        })
        return item
      })
      // this.salesGrowthLineChart.data = {
      // labels: sales_growth_years,
      // series: [sales_growth_series],
      // };
      this.annualSalesGrowthChartData = {
        labels: sales_growth_years,
        series: sales_growth_series.map((item) => ({
          name: item.name,
          data: item.dates,
        })),
      };
      this.salesGrowthLineChart.options.low = sales_growth_chart.min_value_val;
      this.salesGrowthLineChart.options.max = sales_growth_chart.max_value;
      this.vestimateReport.yearsVisible = this.vestimateReport.yearsVisible.filter(function (el) {
        return el != null;
      });
      let return_on_assets_chart = this.vestimateReport.charts.return_on_assets_chart.data;
      let return_on_assets_years = [];
      let return_on_assets_data = [];
      return_on_assets_chart.forEach((element, index) => {
        return_on_assets_years.push(element.date)
      })
      return_on_assets_years = return_on_assets_years.filter(function (item, pos) {
        return return_on_assets_years.indexOf(item) == pos;
      })
      return_on_assets_years = return_on_assets_years.map(item => item.split("-")[0]);
      return_on_assets_chart.forEach((element, index) => {
        let n = {};
        n.name = element.category;
        n.dates = element.value;
        return_on_assets_data.push(n)
      });
      let valueArr5 = return_on_assets_data.map(function (item) {
        return item.name
      });
      let return_on_assets_series = [];
      let uniqueArray5 = [];
      valueArr5.forEach(function (item, idx) {
        if (uniqueArray5.indexOf(item) === -1) {
          uniqueArray5.push(item)
        }
      });
      uniqueArray5.forEach((item, index) => {
        let ff = {};
        let y = [];
        ff.name = item;
        return_on_assets_data.forEach((element, index) => {
          if (element.name == item) {
            y.push(element.dates);
            ff.dates = y;
          }
        });
        return_on_assets_series.push(ff);
      })
      return_on_assets_series.map(item => {
        item.dates = item.dates.map(e => {
          if (e.includes('%')) {
            return e.replace('%', ' ')
          } else {
            return e;
          }
        })
        return item
      });
      this.returnOnAssetsChartData = {
        labels: return_on_assets_years,
        series: return_on_assets_series.map((item) => ({
          name: item.name,
          data: item.dates,
        })),
      };
      let days_receivable_chart = this.vestimateReport.charts.days_receivable_chart.data;
      let days_receivable_years = [];
      let days_receivable_data = [];
      days_receivable_chart.forEach((element, index) => {
        days_receivable_years.push(element.date)
      })
      days_receivable_years = days_receivable_years.filter(function (item, pos) {
        return days_receivable_years.indexOf(item) == pos;
      })
      days_receivable_years = days_receivable_years.map(item => item.split("-")[0]);
      let days_receivable_series = [];
      days_receivable_chart.forEach((element, index) => {
        let n = {};
        n.name = element.category;
        n.dates = element.value;
        days_receivable_data.push(n)
      });
      let valueArr6 = days_receivable_data.map(function (item) {
        return item.name
      });
      let uniqueArray6 = [];
      valueArr6.forEach(function (item, idx) {
        if (uniqueArray6.indexOf(item) === -1) {
          uniqueArray6.push(item)
        }
      });
      uniqueArray6.forEach((item, index) => {
        let ff = {};
        let y = [];
        ff.name = item;
        days_receivable_data.forEach((element, index) => {
          if (element.name == item) {
            y.push(element.dates);
            ff.dates = y;
          }
        });
        days_receivable_series.push(ff);
      })
      days_receivable_series.map(item => {
        item.dates = item.dates.map(e => {
          if (e.includes('%')) {
            return e.replace('%', ' ')
          } else {
            return e
          }
        })
        return item
      })
      this.daysReceivablesChartData = {
        labels: days_receivable_years,
        series: days_receivable_series.map((item) => ({
          name: item.name,
          data: item.dates,
        })),
      };
      let efficiency_index_chart = this.vestimateReport.charts.efficiency_index_chart.data;
      let efficiency_index_years = [];
      let efficiency_index_data = [];
      let efficiency_index_series = [];
      efficiency_index_chart.forEach((element, index) => {
        efficiency_index_years.push(element.date)
      })
      efficiency_index_years = efficiency_index_years.filter(function (item, pos) {
        return efficiency_index_years.indexOf(item) == pos;
      })
      efficiency_index_years = efficiency_index_years.map(item => item.split("-")[0]);
      efficiency_index_chart.forEach((element, index) => {
        let n = {};
        n.name = element.category;
        n.dates = element.value;
        efficiency_index_data.push(n)
      });
      let valueArr7 = efficiency_index_data.map(function (item) {
        return item.name
      });
      let uniqueArray7 = [];
      valueArr7.forEach(function (item, idx) {
        if (uniqueArray7.indexOf(item) === -1) {
          uniqueArray7.push(item)
        }
      });
      uniqueArray7.forEach((item, index) => {
        let ff = {};
        let y = [];
        ff.name = item;
        efficiency_index_data.forEach((element, index) => {
          if (element.name == item) {
            y.push(element.dates);
            ff.dates = y;
          }
        });
        efficiency_index_series.push(ff);
      })
      efficiency_index_series.map(item => {
        item.dates = item.dates.map(e => {
          if (e.includes('%')) {
            return e.replace('%', ' ')
          } else {
            return e
          }
        })
        return item
      })
      this.efficiencyIndexChartData = {
        labels: efficiency_index_years,
        series: efficiency_index_series.map((item) => ({
          name: item.name,
          data: item.dates,
        })),
      };
      let modified_z_chart = this.vestimateReport.charts.modified_z_chart.data;
      let modified_z_years = [];
      let modified_z_data = [];
      let modified_z_series = [];
      modified_z_chart.forEach((element, index) => {
        modified_z_years.push(element.date)
      })
      modified_z_years = modified_z_years.filter(function (item, pos) {
        return modified_z_years.indexOf(item) == pos;
      })
      modified_z_years = modified_z_years.map(item => item.split("-")[0]);
      modified_z_chart.forEach((element, index) => {
        let n = {};
        n.name = element.category;
        n.dates = element.value;
        modified_z_data.push(n)
      });
      let valueArr8 = modified_z_data.map(function (item) {
        return item.name
      });
      let uniqueArray8 = [];
      valueArr8.forEach(function (item, idx) {
        if (uniqueArray8.indexOf(item) === -1) {
          uniqueArray8.push(item)
        }
      });
      uniqueArray8.forEach((item, index) => {
        let ff = {};
        let y = [];
        ff.name = item;
        modified_z_data.forEach((element, index) => {
          if (element.name == item) {
            y.push(element.dates);
            ff.dates = y;
          }
        });
        modified_z_series.push(ff);
      })
      modified_z_series.map(item => {
        item.dates = item.dates.map(e => {
          if (e.includes('%')) {
            return e.replace('%', ' ')
          } else {
            return e
          }
        })
        return item
      })
      this.modifiedZScoreChartData = {
        labels: efficiency_index_years,
        series: modified_z_series.map((item) => ({
          name: item.name,
          data: item.dates,
        })),
      };
      let interest_coverage_chart = this.vestimateReport.charts.interest_coverage_chart.data;
      let interest_coverage_years = [];
      let interest_coverage_data = [];
      let interest_coverage_series = [];
      interest_coverage_chart.forEach((element, index) => {
        interest_coverage_years.push(element.date)
      })
      interest_coverage_years = interest_coverage_years.filter(function (item, pos) {
        return interest_coverage_years.indexOf(item) == pos;
      })
      interest_coverage_years = interest_coverage_years.map(item => item.split("-")[0]);
      interest_coverage_chart.forEach((element, index) => {
        let n = {};
        n.name = element.category;
        n.dates = element.value;
        interest_coverage_data.push(n)
      });
      let valueArr9 = interest_coverage_data.map(function (item) {
        return item.name
      });
      let uniqueArray9 = [];
      valueArr9.forEach(function (item, idx) {
        if (uniqueArray9.indexOf(item) === -1) {
          uniqueArray9.push(item)
        }
      });
      uniqueArray9.forEach((item, index) => {
        let ff = {};
        let y = [];
        ff.name = item;
        interest_coverage_data.forEach((element, index) => {
          if (element.name == item) {
            y.push(element.dates);
            ff.dates = y;
          }
        });
        interest_coverage_series.push(ff);
      })
      interest_coverage_series.map(item => {
        item.dates = item.dates.map(e => {
          if (e.includes('%')) {
            return e.replace('%', ' ')
          } else {
            return e
          }
        })
        return item
      })
      this.interestCoverageChartData = {
        labels: interest_coverage_years,
        series: interest_coverage_series.map((item) => ({
          name: item.name,
          data: item.dates,
        })),
      };
      let total_liabilities_nw_chart = this.vestimateReport.charts.total_liabilities_nw_chart.data;
      let total_liabilities_nw_years = [];
      let total_liabilities_nw_data = [];
      let total_liabilities_nw_series = [];
      total_liabilities_nw_chart.forEach((element, index) => {
        total_liabilities_nw_years.push(element.date)
      })
      total_liabilities_nw_years = total_liabilities_nw_years.filter(function (item, pos) {
        return total_liabilities_nw_years.indexOf(item) == pos;
      })
      total_liabilities_nw_years = total_liabilities_nw_years.map(item => item.split("-")[0]);
      total_liabilities_nw_chart.forEach((element, index) => {
        let n = {};
        n.name = element.category;
        n.dates = element.value;
        total_liabilities_nw_data.push(n)
      });
      let valueArr10 = total_liabilities_nw_data.map(function (item) {
        return item.name
      });
      let uniqueArray10 = [];
      valueArr6.forEach(function (item, idx) {
        if (uniqueArray10.indexOf(item) === -1) {
          uniqueArray10.push(item)
        }
      });
      uniqueArray10.forEach((item, index) => {
        let ff = {};
        let y = [];
        ff.name = item;
        total_liabilities_nw_data.forEach((element, index) => {
          if (element.name == item) {
            y.push(element.dates);
            ff.dates = y;
          }
        });
        total_liabilities_nw_series.push(ff);
      });
      this.test = 1;
      this.test = 3;

      total_liabilities_nw_series.map(item => {
        if(item.dates) {
          item.dates = item.dates.map(e => {
            if (e.includes('%')) {
              return e.replace('%', ' ');
            } else {
              return e;
            }
          });
        }
        return item;
      });

      this.totalLiabilitiesChartData = {
        labels: total_liabilities_nw_years,
        series: total_liabilities_nw_series.map((item) => ({
          name: item.name,
          data: item.dates,
        })),
      };
      this.kpiAverageTotal = 0;

      Object.entries(this.score).forEach(el => {
        if (el[1]['KPI'] != 'n/a') {
          this.average = this.average + parseInt(el[1]['KPI']);
          this.kpiAverageTotal++;
        }
      });

      this.average = this.average / this.kpiAverageTotal;
      this.average = this.average.toFixed(2);

      let tableNames = [
        {
          name: "Income-Expense",
        },
        {
          name: "Revenue",
        },
        {
          name: "Officers Compensation",
        },
        {
          name: "Depreciation",
        },
        {
          name: "Operating Income",
        },
        {
          name: "Interest Expense",
        },
        {
          name: "Pre Tax Net Profit",
        },
        {
          name: "Owner Earnings",
        },
        {
          name: "Balance Sheet",
        },
        {
          name: "Accounts Receivable",
        },
        {
          name: "Total Current Assets",
        },
        {
          name: "Accounts Payable",
        },
        {
          name: "Current Liabilities",
        },
        {
          name: "Total Liabilities",
        },
        {
          name: "Net Worth",
        },
      ]
      fullYears = fullYears.map(Number);
      let x = {};
      x.name = "";
      x.industry = {};
      x.firm = {};
      tableNames.forEach((element, index) => {
        let j = {};
        j.id = index;
        j.industry = {};
        j.firm = {};
        j['name'] = element.name;
        fullYears.forEach((el) => {
          if (this.vestimateReport.IF.data[el][element.name]) {
            if (this.vestimateReport.IF.data[el][element.name].dollar) {
              j.industry[el] = this.vestimateReport.IF.data[el][element.name].percentage;
            } else {
              j.industry[el] = "n/a";
            }
            if (this.vestimateReport.IF.data[el][element.name].firm_dollar) {
              j.firm[el] = this.vestimateReport.IF.data[el][element.name].firm_percentage;
            } else {
              j.firm[el] = "n/a";
            }
          } else {
            j.industry[el] = this.customElementAnalysis(element.name, el, this.vestimateReport.IF.data[el], 'industry');
            j.firm[el] = this.customElementAnalysis(element.name, el, this.vestimateReport.IF.data[el], 'firm');
          }
          x.industry[el] = el;
          x.firm[el] = el;
        })
        this.PercentagesFinancialAnalysis.push(j);
      })
      tableNames.forEach((element, index) => {
        let c = {};
        c.id = index;
        c['name'] = element.name;
        c['dates'] = {};
        fullYears.forEach((el) => {
          if (this.vestimateReport.IF.data[el][element.name]) {
            if (this.vestimateReport.IF.data[el][element.name].variance) {
              c['dates'][el] = this.vestimateReport.IF.data[el][element.name].variance;
            } else {
              c['dates'][el] = "n/a";
            }
          } else {
            c['dates'][el] = this.customElementAnalysis(element.name, el, this.vestimateReport.IF.data[el], 'variance');
          }
        })
        this.VarianceFinancialAnalysis.push(c);
      })
      this.VarianceFinancialAnalysisAux = [...this.VarianceFinancialAnalysis];
      this.VarianceFinancialAnalysis.shift();
      let aux = {};
      aux.name = "";
      aux.industry = {};
      aux.firm = {};
      tableNames.forEach((element, index) => {
        let k = {};
        k.id = index;
        k.industry = {};
        k.firm = {};
        k['name'] = element.name;
        fullYears.forEach((el) => {
          if (this.vestimateReport.IF.data[el][element.name]) {
            if (this.vestimateReport.IF.data[el][element.name].dollar) {
              k.industry[el] = this.vestimateReport.IF.data[el][element.name].dollar;
            } else {
              k.industry[el] = "n/a";
            }
            if (this.vestimateReport.IF.data[el][element.name].firm_dollar) {
              k.firm[el] = this.vestimateReport.IF.data[el][element.name].firm_dollar;
            } else {
              k.firm[el] = "n/a";
            }
          } else {
            k.industry[el] = this.customElementAnalysis(element.name, el, this.vestimateReport.IF.data[el], 'industry');
            k.firm[el] = this.customElementAnalysis(element.name, el, this.vestimateReport.IF.data[el], 'firm');
          }
          aux.industry[el] = el;
          aux.firm[el] = el;
        })
        this.DollarsFinancialAnalysis.push(k);
      })
    },
    numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if (x === null) {
        return x;
      } else {
        return x.replace(/,/g, '.');
      }
    },
    numberWithComma(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else if (x === null) {
        return x;
      } else {
        return x.replace(/,/g, ',');
      }
    },
    switchView: function (type) {
      this.view = type;
    },
    checkName: function (item, type, key) {
      if (item.name === 'Profitability' || item.name == 'Efficiency' || item.name == 'Debt-Risk')
        return true;
      return false;
    },
    checkNameAnalysis: function (item, type, key) {
      if (item.name === 'Balance Sheet')
        return true;
      return false;
    },
    customElementAnalysis: function (name, year, element, type) {
      if (name === "Income-Expense")
        return year;
    },
    customElement: function (name, year, element, type) {
      if (name === "Cash Flow")
        return year;
      else if (name === "Profitability")
        return "";
      else if (name === "Growth" && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2]))
        return this.vestimateReport.IF['timeSeriesShort'];
      else if (name === "Growth")
        return "";
      else if (name === "DOE Growth" && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2]))
        return element['Owner Earnings Growth'].percentage;
      else if (name === "Average Annual Sales Growth" && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2]))
        return element['Sales Growth'].percentage;
      else if (name === "Efficiency")
        return "";
      else if (name === "Debt-Risk")
        return "";
      else if (name === "Market Opportunity" && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2])
          && type === 'industry' && !this.opp_index_exclude)
        return "US";
      else if (name === "Market Opportunity" && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2])
          && type !== 'variance' && type !== 'industry' && !this.all_us && !this.opp_index_exclude)
        return "Local";
      else if (name === "Industry market Growth (" + this.vestimateReport.IF['timeSeriesShort'] + ")"
          && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2]) && type === 'industry' && !this.opp_index_exclude)
        return this.vestimateReport.MR['measures']['Industry Market Growth US'];
      else if (name === "Industry market Growth (" + this.vestimateReport.IF['timeSeriesShort'] + ")"
          && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2]) && type !== 'variance' && type !== 'industry' && !this.all_us && !this.opp_index_exclude)
        return this.vestimateReport.MR['measures']['Industry Market Growth Local'];
      else if (name === "Market Opportunity Index" && type === 'industry')
        return element['Sales/Household Index']['dollar'];
      else
        return "";
    }
  }
}
</script>
<style scoped>
.kpi-details-info h2 {
  font-size: 40px;
  line-height: 48px;
  color: #003666;
  font-weight: 600;
  display: flex;
  align-items: flex-end;
  margin: 0;
}

.if-prfl .md-card-header {
  background: #003666;
  border-radius: 0;
  color: #fff;
}

.if-prfl .md-card-actions {
  background: #ccc;
  padding: 10px !important;
}

.if-prfl .md-button-content {
  float: right;
  width: 35%;
  text-align: right;
}

.card-title {
  color: #fff;
}


.md-card-header h3 {
  margin: 0;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 400;
}

.md-card-chart {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border: 1px solid #d9d9d9;
  border-radius: 0;
  margin: 20px 0;
  -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.15) !important;
  box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.15) !important;
}

.if-prfl .md-card-actions {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 calc(100% - 10px);
  flex: 0 0 calc(100% - 10px);
  margin: 0 5px 5px;
  padding: 10px 15px;
  background-color: rgba(0, 54, 102, 0.2);
  border-top: 1px solid #eeeeee;
  font-size: 14px;
}

.if-prfl .md-card-actions p {
  margin: 0;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: #3c4858;
}

.nowrap {
  max-width: 70% !important;
  padding: 1em !important;
  margin-bottom: .4em !important;
  white-space: nowrap !important;
}
</style>